<template>
  <div>
    <div class="nav-vertical">
      <ul class="nav nav-tabs nav-left" role="tablist">
        <li class="nav-item">
          <a
            class="nav-link active"
            v-bind:href="'#t1' + rowData.docfisId + ''"
            role="tab"
            data-toggle="tab"
          >
            <span class="nav-link-in">
              Ocorrências
              <i class="fa fa-file"></i>
            </span>
          </a>
        </li>
        <li class="nav-item">
          <a
            class="nav-link"
            v-bind:href="'#t2' + rowData.docfisId + ''"
            role="tab"
            data-toggle="tab"
          >
            <span class="nav-link-in">
              Documentos
              <i class="fa fa-file-text"></i>
            </span>
          </a>
        </li>
        <li class="nav-item">
          <a
            class="nav-link"
            v-bind:href="'#t3' + rowData.docfisId + ''"
            v-if="rowData.cargaDocReentrega != null"
            role="tab"
            data-toggle="tab"
          >
            <span class="nav-link-in">
              Doc. Saída
              <i class="fa fa-file-text-o"></i>
            </span>
          </a>
        </li>
        <li class="nav-item">
          <a
            class="nav-link"
            v-bind:href="'#t4' + rowData.docfisId + ''"
            role="tab"
            v-if="rowData.cargaBipDocMany.length > 0"
            data-toggle="tab"
          >
            <span class="nav-link-in">
              Bip Montagem Carga
              <i class="fa fa-barcode"></i>
            </span>
          </a>
        </li>
        <li class="nav-item">
          <a
            class="nav-link"
            v-bind:href="'#t5' + rowData.docfisId + ''"
            role="tab"
            v-if="rowData.cargaBipDocMany.length > 0"
            data-toggle="tab"
          >
            <span class="nav-link-in">
              Bip Expedição
              <i class="fa fa-barcode"></i>
            </span>
          </a>
        </li>
        <li class="nav-item">
          <a
            class="nav-link"
            v-bind:href="'#t7' + rowData.docfisId + ''"
            role="tab"
            data-toggle="tab"
            v-if="
              rowData.cargaDoc != null &&
              rowData.cargaDoc.pedidoUnidadeCargaTrechoDoc[0] != null &&
              rowData.cargaDoc.pedidoUnidadeCargaTrechoDoc[0]
                .pedidoUnidadeCargaTrecho.pedidoUnidadeCargaTrechoAudit !=
                null &&
              rowData.cargaDoc.pedidoUnidadeCargaTrechoDoc[0]
                .pedidoUnidadeCargaTrecho.pedidoUnidadeCargaTrechoAudit
                .auditoriaFrete.docTransp != null
            "
          >
            <span class="nav-link-in">
              Despesa
              <i class="fa fa-money"></i>
            </span>
          </a>
        </li>
        <li class="nav-item">
          <a
            class="nav-link"
            v-bind:href="'#t6' + rowData.docfisId + ''"
            role="tab"
            data-toggle="tab"
            v-if="rowData.docTranspDocfis != null"
          >
            <span class="nav-link-in">
              NFe Agregado
              <i class="fa fa-file-archive-o"></i>
            </span>
          </a>
        </li>
      </ul>
      <div class="tab-content">
        <div
          role="tabpanel"
          class="tab-pane fade in active show"
          v-bind:id="'t1' + rowData.docfisId + ''"
        >
          <table class="table" id="mais">
            <thead>
              <tr>
                <th style="width: 5%">Código</th>
                <th style="width: 15%">Ocorrência</th>
                <th style="width: 10%">Data da Ocorrência</th>
                <th style="width: 10%">Usuario Inc.Ocorrência</th>
                <!--
                  TMS-8396: "Status Integração" passa a abrigar o bloco de
                  diagnóstico da falha, abaixo do badge, e precisa da largura
                  que "Unidade" não usava. A soma das duas é preservada (30%):
                  as 10 colunas já somam 120%, dívida pré-existente que esta
                  task não corrige além destas duas.
                -->
                <th style="width: 20%">Status Integração</th>
                <th style="width: 10%">Unidade</th>
                <th style="width: 10%">Doc</th>
                <th style="width: 10%">Carga</th>
                <th style="width: 15%">Obs da carga</th>
                <th style="width: 15%">Ações</th>
                <!-- <th style="width: 10%">Ações</th> -->
              </tr>
            </thead>
            <tbody v-for="item in rowData.cargaOcorrencia">
              <tr class="bg-gray-light" style="display: table-row">
                <td>
                  {{ item.paramOcorrenciaResource.cd }}
                </td>
                <td>
                  {{ item.paramOcorrenciaResource.descr }}
                </td>
                <td>
                  {{ formatDate(item.dtOcorrencia) }}
                </td>
                <td>
                  <span v-if="item.usuarioInc.pessoa == null">
                    {{ item.usuarioInc.email }}
                  </span>
                  <span
                    v-if="
                      item.usuarioInc.pessoa != null &&
                      item.usuarioInc.pessoa.pessoaFisica != null
                    "
                  >
                    {{
                      setNomeSobrenome(item.usuarioInc.pessoa.pessoaFisica.nome)
                    }}
                  </span>
                </td>
                <td>
                  <span
                    class="badge badge-success"
                    v-if="item.statusIntegracao.valor == 1"
                    >{{ item.statusIntegracao.descr }}</span
                  >
                  <span
                    class="badge badge-warning"
                    v-if="item.statusIntegracao.valor == 2"
                    >{{ item.statusIntegracao.descr }}</span
                  >
                  <span
                    class="badge badge-danger"
                    v-if="item.statusIntegracao.valor == 3"
                    >{{ item.statusIntegracao.descr }}</span
                  >
                  <!--
                    TMS-8396 (ADR-0002 D3): o diagnóstico da falha fica NESTA
                    célula, abaixo do badge — não na coluna Ações, que tem um
                    único elemento e quebraria a linha com dois botões
                    rotulados, e não dentro da linha expandida do `+`, que é
                    condicionada a `item.carga != null` e deixaria a ocorrência
                    sem carga sem diagnóstico nenhum.

                    Sem `v-if` aqui de propósito: `resolverEstadoIntegracao`
                    devolve `null` quando `statusIntegracao.valor != 3` ou
                    quando faltam as 3 chaves novas do backend, e a raiz do
                    componente já é guardada por isso. É esse fail-open que
                    permite este front subir antes de o backend mergear — com o
                    payload de hoje a célula fica idêntica à de hoje.
                  -->
                  <ocorrencia-integracao-erro
                    :item="item"
                    :pode-reenviar="podeReenviarOcorrencia(item)"
                    @reenviar="onReenvioOcorrencia"
                    @copiar-dados-chamado="onCopiarDadosChamado"
                  />
                </td>
                <td>
                  <!--
                    TMS-8396 (ADR-0002 D4): `item.unidade` é a unidade da
                    OCORRÊNCIA. O fallback removido daqui caía em
                    `item.carga.cargaUnidadeCd`, a unidade da CARGA, disparando
                    exatamente quando a da ocorrência era nula — que é a
                    condição da falha `unidade_emissora_nao_resolvida`. A tela
                    exibia unidade preenchida numa linha cuja falha era unidade
                    nula, e foi isso que levou a squad a descartar o
                    diagnóstico correto, por escrito, em 11/09.

                    Marcação explícita, não célula vazia: vazio é
                    indistinguível de "não carregou", e para quem tria o
                    chamado a unidade nula É o achado.
                  -->
                  <span v-if="item.unidade != null">{{
                    item.unidade.cd + " - " + item.unidade.descr
                  }}</span>
                  <span v-else class="text-muted">Sem unidade</span>
                </td>
                <td>
                  <!-- <span v-if="item.doc != null && item.carga != null && item.carga.manifesto == null">{{item.doc.numControle}}</span> -->
                  <span
                    v-if="item.doc != null && item.doc.manifestoDoc != null && item.doc.manifestoDoc.manifesto != null"
                    >MDFe : {{ item.doc.manifestoDoc.manifesto.numFiscal }}</span
                  >
                </td>
                <td>
                  <span v-if="item.carga != null && item.carga.tpCrga != 1">{{
                    item.carga.numCarga
                  }}</span> 
                </td>
                <td>
                  <span v-if="item.carga != null && item.carga.obs != null
                  ">
                    {{ item.carga.obs }}
                  </span>
                </td>
                <td>
                  <a
                    @click="onDetail(item.carocorrenId)"
                    v-b-tooltip
                    v-if="item.carga != null"
                    title="Ver detalhes"
                    ><i class="fa fa-plus"></i
                  ></a>
                </td>
              </tr>
              <tr v-if="isVisibleDetail(item.carocorrenId)">
                <td colspan="12">
                  <section class="tabs-section">
                    <ul
                      class="nav nav-tabs nav-topline nav-justified"
                      role="tablist"
                    >
                      <li class="nav-item">
                        <a
                          class="nav-link active"
                          v-bind:href="'#tr1' + item.carocorrenId + ''"
                          role="tab"
                          data-toggle="tab"
                        >
                          <span class="nav-link-in">
                            Detalhes
                            <i class="fa fa-truck"></i>
                          </span>
                        </a>
                      </li>
                      <li class="nav-item">
                        <a
                          v-if="item.cargaOcorrenciaFoto.length > 0"
                          class="nav-link"
                          v-bind:href="'#tr2' + item.carocorrenId + ''"
                          role="tab"
                          data-toggle="tab"
                        >
                          <span class="nav-link-in">
                            Fotos
                            <i class="fa fa-picture-o"></i>
                          </span>
                        </a>
                      </li>
                    </ul>
                    <div class="tab-content">
                      <div
                        role="tabpanel"
                        class="tab-pane fade in active show pt-1 border-color-detalhes-grey"
                        v-bind:id="'tr1' + item.carocorrenId + ''"
                      >
                        <table
                          :class="['vuetable table table-striped tbl-typical']"
                        >
                          <thead>
                            <tr>
                              <th style="width: 5%">N° Carga</th>
                              <th style="width: 10%">Unidade</th>
                              <th style="width: 30%">Parceiro/Redespacho</th>
                              <th style="width: 20%">Motorista</th>
                              <th style="width: 10%">Placa principal</th>
                              <th style="width: 30%">Transportadora</th>
                              <th style="width: 5%">Status</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr
                              class="bg-gray-light"
                              style="display: table-row"
                            >
                              <td>
                                {{ item.carga.numCarga }}
                              </td>
                              <td>
                                {{ item.carga.cargaUnidadeCd }}
                              </td>
                              <td>
                                <span v-if="item.carga.pessoaParceira != null">
                                  Parceiro:
                                  {{
                                    item.carga.pessoaParceira.pessoaJuridica
                                      .razaoSocial
                                  }}
                                </span>
                                <span
                                  v-if="
                                    rowData.docFiscalPartesEnv
                                      .redCnpj != null
                                  "
                                >
                                  Red :
                                  {{
                                    rowData.docFiscalPartesEnv
                                      .redNome
                                  }}
                                  - CNPJ:
                                  {{
                                    rowData.docFiscalPartesEnv
                                      .redCnpj
                                  }}
                                </span>
                              </td>
                              <td>
                                <span
                                  v-if="
                                    item.carga.cargaMeioTransp.nomeMotorista !=
                                    null
                                  "
                                  >{{
                                    setNomeSobrenome(
                                      item.carga.cargaMeioTransp.nomeMotorista
                                    )
                                  }}</span
                                >
                                <span
                                  v-if="
                                    item.carga.cargaMeioTranspManual != null
                                  "
                                  >{{
                                    setNomeSobrenome(
                                      item.carga.cargaMeioTranspManual.nome
                                    )
                                  }}</span
                                >
                              </td>
                              <td>
                                <span
                                  v-if="
                                    item.carga.cargaMeioTransp
                                      .meioTransportePrimarioPlaca != null
                                  "
                                  >{{
                                    item.carga.cargaMeioTransp
                                      .meioTransportePrimarioPlaca
                                  }}</span
                                >
                                <span
                                  v-if="
                                    item.carga.cargaMeioTranspManual != null
                                  "
                                  >{{
                                    item.carga.cargaMeioTranspManual
                                      .placaPrimaria
                                  }}</span
                                >
                              </td>
                              <td>
                                <span v-if="item.carga.pessoa != null">{{
                                  item.carga.pessoa.pessoaJuridica.razaoSocial
                                }}</span>
                              </td>
                              <td>
                                <span
                                  class="badge badge-info"
                                  v-if="item.carga.status.valor == 6"
                                  >{{ item.carga.status.descr }}</span
                                >
                                <span
                                  class="badge badge-success"
                                  v-if="item.carga.status.valor == 3"
                                  >{{ item.carga.status.descr }}</span
                                >
                                <span
                                  class="badge badge-warning"
                                  v-if="item.carga.status.valor == 2"
                                  >{{ item.carga.status.descr }}</span
                                >
                                <span
                                  class="badge badge-warning"
                                  v-if="item.carga.status.valor == 1"
                                  >{{ item.carga.status.descr }}</span
                                >
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>

                      <div
                        role="tabpanel"
                        class="tab-pane fade in pt-1 border-color-detalhes-grey"
                        v-bind:id="'tr2' + item.carocorrenId + ''"
                      >
                        <table
                          :class="['vuetable table table-striped tbl-typical']"
                        >
                          <thead>
                            <tr>
                              <th style="width: 10%">N° da foto</th>
                              <th style="width: 35%">Link</th>
                            </tr>
                          </thead>
                          <tbody
                            v-for="(item_itens, i) in item.cargaOcorrenciaFoto"
                          >
                            <tr
                              class="bg-gray-light"
                              style="display: table-row"
                            >
                              <td>
                                {{ i + 1 }}
                              </td>
                              <td>
                                <a
                                  @click="goLink(item_itens.urlFoto)"
                                  target="_blank"
                                  >{{ item_itens.nomeFoto }}</a
                                >
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </section>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <!--.tab-pane-->
        <div
          role="tabpanel"
          class="tab-pane fade"
          v-bind:id="'t2' + rowData.docfisId + ''"
        >
          <table class="table" id="mais">
            <thead>
              <tr>
                <th style="width: 5%">N° Doc</th>
                <th style="width: 10%">Dt Emissão Doc</th>
                <th style="width: 5%">Valor Doc</th>
                <th style="width: 5%">Peso Bruto</th>
                <th style="width: 10%">Processo</th>
                <th style="width: 10%">Operação</th>
                <th style="width: 10%">N° carga tracking</th>
                <th style="width: 10%">Usuario Emissor</th>
                <th style="width: 5%">Qtd. de notas</th>
                <th style="width: 15%">Região</th>
                <th style="width: 5%">Status</th>
                <th style="width: 5%">Ações</th>
              </tr>
            </thead>
            <tbody v-for="item in rowData.cargaDocReentrega">
              <tr v-if="item.docCargaDoc" class="bg-gray-light" style="display: table-row">
                <td>
                  {{ item.docCargaDoc ? item.docCargaDoc.doc.numFiscal : '' }}
                </td>
                <td>
                  {{ item.docCargaDoc ? formatDate(item.docCargaDoc.doc.dtEmi) : '' }}
                </td>
                <td><span v-if="item.docCargaDoc">R$ {{ formatNumber(item.docCargaDoc.doc.vlrReceber) }}</span></td>
                <td>
                  <span v-if="item.docCargaDoc.doc.docCte != null"
                    >{{
                      formatNumber(
                        item.docCargaDoc.doc.docCte.docCteCarga[0].qtd
                      )
                    }}
                    {{
                      item.docCargaDoc.doc.docCte.docCteCarga[0]
                        .paramUnidadeMedida.descr
                    }}</span
                  >
                </td>
                <td>
                  {{ item.docCargaDoc.doc.tpProcesso.descr }}
                </td>
                <td>
                  {{ item.docCargaDoc.doc.tpOperacao.descr }}
                </td>
                <td>
                  <span
                    v-if="showMdfe(item)"
                  >
                    {{ item.docCargaDoc.doc.manifestoDoc.manifesto.numCargaItrack }}
                  </span>
                  <span
                    v-if="
                      rowData.docFiscalTracking != null &&
                      (
                        item.docCargaDoc == null ||
                        item.docCargaDoc.doc == null ||
                        item.docCargaDoc.doc.manifestoDoc == null ||
                        item.docCargaDoc.doc.manifestoDoc.manifesto == null
                      )
                    "
                  >
                    {{ rowData.docFiscalTracking }}
                  </span>
                </td>
                <td>
                  <span v-if="item.docCargaDoc.doc.usuarioInc.pessoa != null">
                    {{
                      setNomeSobrenome(
                        item.docCargaDoc.doc.usuarioInc.pessoa.pessoaFisica.nome
                      )
                    }}
                  </span>
                  <span v-if="item.docCargaDoc.doc.usuarioInc.pessoa == null">
                    {{ item.docCargaDoc.doc.usuarioInc.email }}
                  </span>
                </td>
                <td>
                  {{ rowData.qtdTotalNotasCte }}
                </td>
                <td>
                  <span
                    v-if="item != null && item.docCargaDoc.doc.tpDoc.valor == 2"
                  >
                    {{ item.docCargaDoc.doc.docRps.docRpsRegiao }}
                  </span>
                  <span
                    v-if="
                      item != null &&
                      item.docCargaDoc.doc.tpDoc.valor == 1 &&
                      item.docCargaDoc.doc.regiaoDespesa != null
                    "
                  >
                    {{
                      item.docCargaDoc.doc.regiaoDespesa.cd +
                      " - " +
                      item.docCargaDoc.doc.regiaoDespesa.descr
                    }}
                  </span>
                </td>
                <td>
                  <span
                    class="badge badge-danger"
                    v-if="
                      item.docCargaDoc.doc.tpDoc.valor == 1 &&
                      item.docCargaDoc.doc.docCte.statusSefaz.valor == 1
                    "
                    >{{ item.docCargaDoc.doc.docCte.statusSefaz.descr }}</span
                  >
                  <span
                    class="badge badge-warning"
                    v-if="
                      item.docCargaDoc.doc.tpDoc.valor == 1 &&
                      item.docCargaDoc.doc.docCte.statusSefaz.valor == 2
                    "
                    >{{ item.docCargaDoc.doc.docCte.statusSefaz.descr }}</span
                  >
                  <span
                    class="badge badge-info"
                    v-if="
                      item.docCargaDoc.doc.tpDoc.valor == 1 &&
                      item.docCargaDoc.doc.docCte.statusSefaz.valor == 3
                    "
                    >{{ item.docCargaDoc.doc.docCte.statusSefaz.descr }}</span
                  >
                  <span
                    class="badge badge-success"
                    v-if="
                      item.docCargaDoc.doc.tpDoc.valor == 1 &&
                      item.docCargaDoc.doc.docCte.statusSefaz.valor == 4
                    "
                    >{{ item.docCargaDoc.doc.docCte.statusSefaz.descr }}</span
                  >
                  <span
                    class="badge badge-success"
                    v-if="
                      item.docCargaDoc.doc.tpDoc.valor == 1 &&
                      item.docCargaDoc.doc.docCte.statusSefaz.valor == 6
                    "
                    >{{ item.docCargaDoc.doc.docCte.statusSefaz.descr }}</span
                  >
                  <span
                    class="badge badge-success"
                    v-if="
                      item.docCargaDoc.doc.tpDoc.valor == 1 &&
                      item.docCargaDoc.doc.docCte.statusSefaz.valor == 8
                    "
                    >{{ item.docCargaDoc.doc.docCte.statusSefaz.descr }}</span
                  >
                  <span
                    class="badge badge-info"
                    v-if="
                      item.docCargaDoc.doc.tpDoc.valor == 1 &&
                      item.docCargaDoc.doc.docCte.statusSefaz.valor == 5
                    "
                    >{{ item.docCargaDoc.doc.docCte.statusSefaz.descr }}</span
                  >
                  <span
                    class="badge badge-danger"
                    v-if="
                      item.docCargaDoc.doc.tpDoc.valor == 1 &&
                      item.docCargaDoc.doc.docCte.statusSefaz.valor == 7
                    "
                    >{{ item.docCargaDoc.doc.docCte.statusSefaz.descr }}</span
                  >
                </td>
                <td>
                  <a
                    @click="onDetail(item.docCargaDoc.docId)"
                    v-b-tooltip
                    title="Ver Detalhes"
                    ><i class="fa fa-plus"></i
                  ></a>
                  <span
                    v-if="
                      item.docCargaDoc.doc.tpDoc.valor == 1 &&
                      item.docCargaDoc.doc.docCte.statusSefaz.valor == 4
                    "
                  >
                    <a
                      @click="
                        onImprimirXml(
                          item.docCargaDoc.doc.docId,
                          1,
                          item.docCargaDoc.doc.tpDoc.valor
                        )
                      "
                      v-if="item.docCargaDoc.doc.docCte.docCteXml.length > 0"
                      v-b-tooltip
                      title="Imprimir Dacte"
                    >
                      <i class="fa fa-download"></i>
                    </a>
                  </span>
                  <span v-if="getPermission('cte.imprimir')">
                    <span
                      v-if="
                        item.docCargaDoc.doc.tpDoc.valor == 1 &&
                        (item.docCargaDoc.doc.docCte.statusSefaz.valor == 4 ||
                          item.docCargaDoc.doc.docCte.statusSefaz.valor == 7)
                      "
                    >
                      <a
                        @click="
                          onDownloadXml(
                            item.docCargaDoc.doc.docCte.doccteId,
                            null
                          )
                        "
                        v-if="
                          (item.docCargaDoc.doc.docCte != null &&
                            item.docCargaDoc.doc.docCte.docCteXml.length > 0) ||
                          item.docCargaDoc.doc.docCte.docCteXml.length > 0
                        "
                        v-b-tooltip
                        title="Download XML"
                        ><i class="fa fa-code"></i
                      ></a>
                    </span>
                  </span>
                  <div v-if="item.docCargaDoc.doc.tpDoc.valor == 2">
                    <span v-if="getPermission('cte.imprimir')">
                      <span>
                        <a
                          @click="
                            onDownloadXml(
                              null,
                              item.docCargaDoc.doc.docRps.docrpsId
                            )
                          "
                          v-if="
                            item.docCargaDoc.doc.docRps.docRpsXml.length > 0
                          "
                          v-b-tooltip
                          title="Download XML"
                          ><i class="fa fa-code"></i
                        ></a>
                      </span>
                    </span>
                  </div>
                  <span v-if="rowData.cargaDoc.docCargaDoc">
                    <span>
                      <a
                        @click="
                          onImprimirRps(
                            item.docCargaDoc.doc.docId,
                            item.docCargaDoc.doc.tpDoc.valor
                          )
                        "
                        v-if="rowData.cargaDoc.docCargaDoc.doc.docRps != null"
                        v-b-tooltip
                        title="Imprimir RPS"
                        ><i class="fa fa-download"></i
                      ></a>
                    </span>
                  </span>
                </td>
              </tr>
              <tr v-if="item.docCargaDoc && isVisibleDetail(item.docCargaDoc.docId)">
                <td colspan="12">
                  <section class="tabs-section">
                    <ul
                      class="nav nav-tabs nav-topline nav-justified"
                      role="tablist"
                    >
                      <li class="nav-item">
                        <a
                          class="nav-link active"
                          v-bind:href="'#tr3' + item.docCargaDoc.docId + ''"
                          role="tab"
                          data-toggle="tab"
                        >
                          <span class="nav-link-in">
                            Partes Env.
                            <i class="fa fa-users"></i>
                          </span>
                        </a>
                      </li>
                      <li class="nav-item">
                        <a
                          class="nav-link"
                          v-bind:href="'#tr2' + item.docCargaDoc.docId + ''"
                          role="tab"
                          data-toggle="tab"
                        >
                          <span class="nav-link-in">
                            Calculo - Tabela Receita
                            <i class="fa fa-file-excel-o"></i>
                          </span>
                        </a>
                      </li>
                    </ul>
                    <div class="tab-content">
                      <div
                        role="tabpanel"
                        class="tab-pane fade in active show pt-1 border-color-detalhes-grey"
                        v-bind:id="'tr3' + item.docCargaDoc.docId + ''"
                      >
                        <table
                          :class="['vuetable table table-striped tbl-typical']"
                        >
                          <thead>
                            <tr>
                              <th data-toggle="true" style="width: 10%"></th>
                              <th data-toggle="true" style="width: 10%">
                                CNPJ / CPF
                              </th>
                              <th data-toggle="true" style="width: 10%">IE</th>
                              <th data-toggle="true" style="width: 10%">
                                Nome
                              </th>
                              <th data-toggle="true" style="width: 10%">
                                Município
                              </th>
                              <th data-toggle="true" style="width: 3%">
                                Estado
                              </th>
                              <th data-toggle="true" style="width: 15%">
                                Endereço
                              </th>
                              <th data-toggle="true" style="width: 12%">
                                Bairro
                              </th>
                              <th data-toggle="true" style="width: 10%">CEP</th>
                              <th data-toggle="true" style="width: 10%">
                                Email
                              </th>
                              <th data-toggle="true" style="width: 5%">
                                Telefone
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr
                              class="bg-gray-light"
                              style="display: table-row"
                              v-if="
                                item.docCargaDoc.doc.docCtePartesEnv.emiEndereco
                              "
                            >
                              <td>
                                <span class="badge badge-primary"
                                  >Emitente</span
                                >
                              </td>
                              <td>
                                <span
                                  v-if="
                                    item.docCargaDoc.doc.docCtePartesEnv
                                      .eminpj != null
                                  "
                                >
                                  {{
                                    ajustaMascara(
                                      item.docCargaDoc.doc.docCtePartesEnv
                                        .emiCnpj
                                    )
                                  }}
                                </span>
                                <span
                                  v-if="
                                    item.docCargaDoc.doc.docCtePartesEnv
                                      .emiCpf != null
                                  "
                                >
                                  {{
                                    ajustaMascara(
                                      item.docCargaDoc.doc.docCtePartesEnv
                                        .emiCpf
                                    )
                                  }}
                                </span>
                              </td>
                              <td>
                                {{ item.docCargaDoc.doc.docCtePartesEnv.emiIe }}
                              </td>
                              <td>
                                {{
                                  item.docCargaDoc.doc.docCtePartesEnv.emiNome
                                }}
                              </td>
                              <td>
                                {{
                                  item.docCargaDoc.doc.docCtePartesEnv
                                    .emiNomeMunicipio
                                }}
                              </td>
                              <td>
                                {{ item.docCargaDoc.doc.docCtePartesEnv.emiUf }}
                              </td>
                              <td>
                                {{
                                  item.docCargaDoc.doc.docCtePartesEnv
                                    .emiEndereco
                                }}
                                -
                                {{
                                  item.docCargaDoc.doc.docCtePartesEnv
                                    .emiComplemento
                                }}
                                -
                                {{
                                  item.docCargaDoc.doc.docCtePartesEnv.emiNumero
                                }}
                              </td>
                              <td>
                                {{
                                  item.docCargaDoc.doc.docCtePartesEnv.emiBairro
                                }}
                              </td>
                              <td>
                                <span
                                  v-if="
                                    item.docCargaDoc.doc.docCtePartesEnv.emiCep
                                  "
                                  >{{
                                    item.docCargaDoc.doc.docCtePartesEnv.emiCep
                                      .toString()
                                      .padStart(8, "0")
                                  }}</span
                                >
                              </td>
                              <td>
                                <span
                                  v-if="
                                    item.docCargaDoc.doc.docCtePartesEnv
                                      .emiEmail
                                  "
                                  >{{
                                    item.docCargaDoc.doc.docCtePartesEnv
                                      .emiEmail
                                  }}</span
                                >
                              </td>
                              <td>
                                <span
                                  v-if="
                                    item.docCargaDoc.doc.docCtePartesEnv
                                      .emiTelefone
                                  "
                                  >{{
                                    item.docCargaDoc.doc.docCtePartesEnv
                                      .emiTelefone
                                  }}</span
                                >
                              </td>
                            </tr>
                          </tbody>
                          <tbody>
                            <tr
                              class="bg-gray-light"
                              style="display: table-row"
                              v-if="
                                item.docCargaDoc.doc.docCtePartesEnv.remEndereco
                              "
                            >
                              <td>
                                <span class="badge badge-warning"
                                  >Remetente</span
                                >
                              </td>
                              <td>
                                <span
                                  v-if="
                                    item.docCargaDoc.doc.docCtePartesEnv
                                      .remCnpj != null
                                  "
                                >
                                  {{
                                    ajustaMascara(
                                      item.docCargaDoc.doc.docCtePartesEnv
                                        .remCnpj
                                    )
                                  }}
                                </span>
                                <span
                                  v-if="
                                    item.docCargaDoc.doc.docCtePartesEnv
                                      .remCpf != null
                                  "
                                >
                                  {{
                                    ajustaMascara(
                                      item.docCargaDoc.doc.docCtePartesEnv
                                        .remCpf
                                    )
                                  }}
                                </span>
                              </td>
                              <td>
                                {{ item.docCargaDoc.doc.docCtePartesEnv.remIe }}
                              </td>
                              <td>
                                {{
                                  item.docCargaDoc.doc.docCtePartesEnv.remNome
                                }}
                              </td>
                              <td>
                                {{
                                  item.docCargaDoc.doc.docCtePartesEnv
                                    .remNomeMunicipio
                                }}
                              </td>
                              <td>
                                {{ item.docCargaDoc.doc.docCtePartesEnv.remUf }}
                              </td>
                              <td>
                                {{
                                  item.docCargaDoc.doc.docCtePartesEnv
                                    .remEndereco
                                }}
                                -
                                {{
                                  item.docCargaDoc.doc.docCtePartesEnv
                                    .remComplemento
                                }}
                                -
                                {{
                                  item.docCargaDoc.doc.docCtePartesEnv.remNumero
                                }}
                              </td>
                              <td>
                                {{
                                  item.docCargaDoc.doc.docCtePartesEnv.remBairro
                                }}
                              </td>
                              <td>
                                <span
                                  v-if="
                                    item.docCargaDoc.doc.docCtePartesEnv.remCep
                                  "
                                  >{{
                                    item.docCargaDoc.doc.docCtePartesEnv.remCep
                                      .toString()
                                      .padStart(8, "0")
                                  }}</span
                                >
                              </td>
                              <td>
                                <span
                                  v-if="
                                    item.docCargaDoc.doc.docCtePartesEnv
                                      .remEmail
                                  "
                                  >{{
                                    item.docCargaDoc.doc.docCtePartesEnv
                                      .remEmail
                                  }}</span
                                >
                              </td>
                              <td>
                                <span
                                  v-if="
                                    item.docCargaDoc.doc.docCtePartesEnv
                                      .remTelefone
                                  "
                                  >{{
                                    item.docCargaDoc.doc.docCtePartesEnv
                                      .remTelefone
                                  }}</span
                                >
                              </td>
                            </tr>
                          </tbody>
                          <tbody>
                            <tr
                              class="bg-gray-light"
                              style="display: table-row"
                              v-if="
                                item.docCargaDoc.doc.docCtePartesEnv.expEndereco
                              "
                            >
                              <td>
                                <span class="badge badge-info">Expedidor</span>
                              </td>
                              <td>
                                <span
                                  v-if="
                                    item.docCargaDoc.doc.docCtePartesEnv
                                      .expCnpj != null
                                  "
                                >
                                  {{
                                    ajustaMascara(
                                      item.docCargaDoc.doc.docCtePartesEnv
                                        .expCnpj
                                    )
                                  }}
                                </span>
                                <span
                                  v-if="
                                    item.docCargaDoc.doc.docCtePartesEnv
                                      .expCpf != null
                                  "
                                >
                                  {{
                                    ajustaMascara(
                                      item.docCargaDoc.doc.docCtePartesEnv
                                        .expCpf
                                    )
                                  }}
                                </span>
                              </td>
                              <td>
                                {{ item.docCargaDoc.doc.docCtePartesEnv.expIe }}
                              </td>
                              <td>
                                {{
                                  item.docCargaDoc.doc.docCtePartesEnv.expNome
                                }}
                              </td>
                              <td>
                                {{
                                  item.docCargaDoc.doc.docCtePartesEnv
                                    .expNomeMunicipio
                                }}
                              </td>
                              <td>
                                {{ item.docCargaDoc.doc.docCtePartesEnv.expUf }}
                              </td>
                              <td>
                                {{
                                  item.docCargaDoc.doc.docCtePartesEnv
                                    .expEndereco
                                }}
                                -
                                {{
                                  item.docCargaDoc.doc.docCtePartesEnv
                                    .expComplemento
                                }}
                                -
                                {{
                                  item.docCargaDoc.doc.docCtePartesEnv.expNumero
                                }}
                              </td>
                              <td>
                                {{
                                  item.docCargaDoc.doc.docCtePartesEnv.expBairro
                                }}
                              </td>
                              <td>
                                <span
                                  v-if="
                                    item.docCargaDoc.doc.docCtePartesEnv.expCep
                                  "
                                  >{{
                                    item.docCargaDoc.doc.docCtePartesEnv.expCep
                                      .toString()
                                      .padStart(8, "0")
                                  }}</span
                                >
                              </td>
                              <td>
                                <span
                                  v-if="
                                    item.docCargaDoc.doc.docCtePartesEnv
                                      .expEmail
                                  "
                                  >{{
                                    item.docCargaDoc.doc.docCtePartesEnv
                                      .expEmail
                                  }}</span
                                >
                              </td>
                              <td>
                                <span
                                  v-if="
                                    item.docCargaDoc.doc.docCtePartesEnv
                                      .expTelefone
                                  "
                                  >{{
                                    item.docCargaDoc.doc.docCtePartesEnv
                                      .expTelefone
                                  }}</span
                                >
                              </td>
                            </tr>
                          </tbody>
                          <tbody>
                            <tr
                              class="bg-gray-light"
                              style="display: table-row"
                              v-if="
                                item.docCargaDoc.doc.docCtePartesEnv.desEndereco
                              "
                            >
                              <td>
                                <span class="badge badge-success"
                                  >Destinatário</span
                                >
                              </td>
                              <td>
                                <span
                                  v-if="
                                    item.docCargaDoc.doc.docCtePartesEnv
                                      .desCnpj != null
                                  "
                                >
                                  {{
                                    ajustaMascara(
                                      item.docCargaDoc.doc.docCtePartesEnv
                                        .desCnpj
                                    )
                                  }}
                                </span>
                                <span
                                  v-if="
                                    item.docCargaDoc.doc.docCtePartesEnv
                                      .desCpf != null
                                  "
                                >
                                  {{
                                    ajustaMascara(
                                      item.docCargaDoc.doc.docCtePartesEnv
                                        .desCpf
                                    )
                                  }}
                                </span>
                              </td>
                              <td>
                                {{ item.docCargaDoc.doc.docCtePartesEnv.desIe }}
                              </td>
                              <td>
                                {{
                                  item.docCargaDoc.doc.docCtePartesEnv.desNome
                                }}
                              </td>
                              <td>
                                {{
                                  item.docCargaDoc.doc.docCtePartesEnv
                                    .desNomeMunicipio
                                }}
                              </td>
                              <td>
                                {{ item.docCargaDoc.doc.docCtePartesEnv.desUf }}
                              </td>
                              <td>
                                {{
                                  item.docCargaDoc.doc.docCtePartesEnv
                                    .desEndereco
                                }}
                                -
                                {{
                                  item.docCargaDoc.doc.docCtePartesEnv
                                    .desComplemento
                                }}
                                -
                                {{
                                  item.docCargaDoc.doc.docCtePartesEnv.desNumero
                                }}
                              </td>
                              <td>
                                {{
                                  item.docCargaDoc.doc.docCtePartesEnv.desBairro
                                }}
                              </td>
                              <td>
                                <span
                                  v-if="
                                    item.docCargaDoc.doc.docCtePartesEnv.desCep
                                  "
                                  >{{
                                    item.docCargaDoc.doc.docCtePartesEnv.desCep
                                      .toString()
                                      .padStart(8, "0")
                                  }}</span
                                >
                              </td>
                              <td>
                                <span
                                  v-if="
                                    item.docCargaDoc.doc.docCtePartesEnv
                                      .desEmail
                                  "
                                  >{{
                                    item.docCargaDoc.doc.docCtePartesEnv
                                      .desEmail
                                  }}</span
                                >
                              </td>
                              <td>
                                <span
                                  v-if="
                                    item.docCargaDoc.doc.docCtePartesEnv
                                      .desTelefone
                                  "
                                  >{{
                                    item.docCargaDoc.doc.docCtePartesEnv
                                      .desTelefone
                                  }}</span
                                >
                              </td>
                            </tr>
                          </tbody>
                          <tbody>
                            <tr
                              class="bg-gray-light"
                              style="display: table-row"
                              v-if="
                                item.docCargaDoc.doc.docCtePartesEnv.recEndereco
                              "
                            >
                              <td>
                                <span class="badge badge-secondary"
                                  >Recebedor</span
                                >
                              </td>
                              <td>
                                <span
                                  v-if="
                                    item.docCargaDoc.doc.docCtePartesEnv
                                      .recCnpj != null
                                  "
                                >
                                  {{
                                    ajustaMascara(
                                      item.docCargaDoc.doc.docCtePartesEnv
                                        .recCnpj
                                    )
                                  }}
                                </span>
                                <span
                                  v-if="
                                    item.docCargaDoc.doc.docCtePartesEnv
                                      .recCpf != null
                                  "
                                >
                                  {{
                                    ajustaMascara(
                                      item.docCargaDoc.doc.docCtePartesEnv
                                        .recCpf
                                    )
                                  }}
                                </span>
                              </td>
                              <td>
                                {{ item.docCargaDoc.doc.docCtePartesEnv.recIe }}
                              </td>
                              <td>
                                {{
                                  item.docCargaDoc.doc.docCtePartesEnv.recNome
                                }}
                              </td>
                              <td>
                                {{
                                  item.docCargaDoc.doc.docCtePartesEnv
                                    .recNomeMunicipio
                                }}
                              </td>
                              <td>
                                {{ item.docCargaDoc.doc.docCtePartesEnv.recUf }}
                              </td>
                              <td>
                                {{
                                  item.docCargaDoc.doc.docCtePartesEnv
                                    .recEndereco
                                }}
                                -
                                {{
                                  item.docCargaDoc.doc.docCtePartesEnv
                                    .recComplemento
                                }}
                                -
                                {{
                                  item.docCargaDoc.doc.docCtePartesEnv.recNumero
                                }}
                              </td>
                              <td>
                                {{
                                  item.docCargaDoc.doc.docCtePartesEnv.recBairro
                                }}
                              </td>
                              <td>
                                <span
                                  v-if="
                                    item.docCargaDoc.doc.docCtePartesEnv.recCep
                                  "
                                  >{{
                                    item.docCargaDoc.doc.docCtePartesEnv.recCep
                                      .toString()
                                      .padStart(8, "0")
                                  }}</span
                                >
                              </td>
                              <td>
                                <span
                                  v-if="
                                    item.docCargaDoc.doc.docCtePartesEnv
                                      .recEmail
                                  "
                                  >{{
                                    item.docCargaDoc.doc.docCtePartesEnv
                                      .recEmail
                                  }}</span
                                >
                              </td>
                              <td>
                                <span
                                  v-if="
                                    item.docCargaDoc.doc.docCtePartesEnv
                                      .recTelefone
                                  "
                                  >{{
                                    item.docCargaDoc.doc.docCtePartesEnv
                                      .recTelefone
                                  }}</span
                                >
                              </td>
                            </tr>
                          </tbody>
                          <tbody>
                            <tr
                              class="bg-gray-light"
                              style="display: table-row"
                              v-if="
                                item.docCargaDoc.doc.docCtePartesEnv.tomEndereco
                              "
                            >
                              <td>
                                <span class="badge badge-primary">Tomador</span>
                              </td>
                              <td>
                                <span
                                  v-if="
                                    item.docCargaDoc.doc.docCtePartesEnv
                                      .tomCnpj != null
                                  "
                                >
                                  {{
                                    ajustaMascara(
                                      item.docCargaDoc.doc.docCtePartesEnv
                                        .tomCnpj
                                    )
                                  }}
                                </span>
                                <span
                                  v-if="
                                    item.docCargaDoc.doc.docCtePartesEnv
                                      .tomCpf != null
                                  "
                                >
                                  {{
                                    ajustaMascara(
                                      item.docCargaDoc.doc.docCtePartesEnv
                                        .tomCpf
                                    )
                                  }}
                                </span>
                              </td>
                              <td>
                                {{ item.docCargaDoc.doc.docCtePartesEnv.tomIe }}
                              </td>
                              <td>
                                {{
                                  item.docCargaDoc.doc.docCtePartesEnv.tomNome
                                }}
                              </td>
                              <td>
                                {{
                                  item.docCargaDoc.doc.docCtePartesEnv
                                    .tomNomeMunicipio
                                }}
                              </td>
                              <td>
                                {{ item.docCargaDoc.doc.docCtePartesEnv.tomUf }}
                              </td>
                              <td>
                                {{
                                  item.docCargaDoc.doc.docCtePartesEnv
                                    .tomEndereco
                                }}
                                -
                                {{
                                  item.docCargaDoc.doc.docCtePartesEnv
                                    .tomComplemento
                                }}
                                -
                                {{
                                  item.docCargaDoc.doc.docCtePartesEnv.tomNumero
                                }}
                              </td>
                              <td>
                                {{
                                  item.docCargaDoc.doc.docCtePartesEnv.tomBairro
                                }}
                              </td>
                              <td>
                                <span
                                  v-if="
                                    item.docCargaDoc.doc.docCtePartesEnv.tomCep
                                  "
                                  >{{
                                    item.docCargaDoc.doc.docCtePartesEnv.tomCep
                                      .toString()
                                      .padStart(8, "0")
                                  }}</span
                                >
                              </td>
                              <td>
                                <span
                                  v-if="
                                    item.docCargaDoc.doc.docCtePartesEnv
                                      .tomEmail
                                  "
                                  >{{
                                    item.docCargaDoc.doc.docCtePartesEnv
                                      .tomEmail
                                  }}</span
                                >
                              </td>
                              <td>
                                <span
                                  v-if="
                                    item.docCargaDoc.doc.docCtePartesEnv
                                      .tomTelefone
                                  "
                                  >{{
                                    item.docCargaDoc.doc.docCtePartesEnv
                                      .tomTelefone
                                  }}</span
                                >
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                      <!--.tab-pane-->
                      <div
                        role="tabpanel"
                        class="tab-pane fade in pt-1 border-color-detalhes-grey"
                        v-bind:id="'tr2' + item.docCargaDoc.docId + ''"
                      >
                        <b-tabs>
                          <b-tab title="Rota" active>
                            <b-row
                              class="p-a-0"
                              id="row"
                              style="margin-top: 10px"
                            >
                              <b-col md="3">
                                <label>Municipio de Origem: </label>
                                <span
                                  v-if="
                                    item.docCargaDoc.cargaDoc
                                      .cargaDocUnidadeCarga[0]
                                      .pedidoUnidadeCarga
                                      .pedidoUnidadeCargaTrecho[0]
                                      .tabelaFreteRotaVig.tabelaFreteRota
                                      .municipioOrigem != null
                                  "
                                >
                                  {{
                                    item.docCargaDoc.cargaDoc
                                      .cargaDocUnidadeCarga[0]
                                      .pedidoUnidadeCarga
                                      .pedidoUnidadeCargaTrecho[0]
                                      .tabelaFreteRotaVig.tabelaFreteRota
                                      .municipioOrigem.nome
                                  }}
                                  -
                                  {{
                                    item.docCargaDoc.cargaDoc
                                      .cargaDocUnidadeCarga[0]
                                      .pedidoUnidadeCarga
                                      .pedidoUnidadeCargaTrecho[0]
                                      .tabelaFreteRotaVig.tabelaFreteRota
                                      .municipioOrigem.uf.cd
                                  }}</span
                                >
                                <span
                                  v-if="
                                    item.docCargaDoc.cargaDoc
                                      .cargaDocUnidadeCarga[0]
                                      .pedidoUnidadeCarga
                                      .pedidoUnidadeCargaTrecho[0]
                                      .tabelaFreteRotaVig.tabelaFreteRota
                                      .municipioOrigem == null
                                  "
                                >
                                  Não constado</span
                                >
                              </b-col>
                              <b-col md="3">
                                <label>Municipio de Destino: </label>
                                <span
                                  v-if="
                                    item.docCargaDoc.cargaDoc
                                      .cargaDocUnidadeCarga[0]
                                      .pedidoUnidadeCarga
                                      .pedidoUnidadeCargaTrecho[0]
                                      .tabelaFreteRotaVig.tabelaFreteRota
                                      .municipioDestino != null
                                  "
                                >
                                  {{
                                    item.docCargaDoc.cargaDoc
                                      .cargaDocUnidadeCarga[0]
                                      .pedidoUnidadeCarga
                                      .pedidoUnidadeCargaTrecho[0]
                                      .tabelaFreteRotaVig.tabelaFreteRota
                                      .municipioDestino.nome
                                  }}
                                  -
                                  {{
                                    item.docCargaDoc.cargaDoc
                                      .cargaDocUnidadeCarga[0]
                                      .pedidoUnidadeCarga
                                      .pedidoUnidadeCargaTrecho[0]
                                      .tabelaFreteRotaVig.tabelaFreteRota
                                      .municipioDestino.uf.cd
                                  }}</span
                                >
                                <span
                                  v-if="
                                    item.docCargaDoc.cargaDoc
                                      .cargaDocUnidadeCarga[0]
                                      .pedidoUnidadeCarga
                                      .pedidoUnidadeCargaTrecho[0]
                                      .tabelaFreteRotaVig.tabelaFreteRota
                                      .municipioDestino == null
                                  "
                                >
                                  Não constado</span
                                >
                              </b-col>
                              <b-col md="3">
                                <label>Região de Origem: </label>
                                <span
                                  v-if="
                                    item.docCargaDoc.cargaDoc
                                      .cargaDocUnidadeCarga[0]
                                      .pedidoUnidadeCarga
                                      .pedidoUnidadeCargaTrecho[0]
                                      .tabelaFreteRotaVig.tabelaFreteRota
                                      .regiaoOrigem != null
                                  "
                                >
                                  {{
                                    item.docCargaDoc.cargaDoc
                                      .cargaDocUnidadeCarga[0]
                                      .pedidoUnidadeCarga
                                      .pedidoUnidadeCargaTrecho[0]
                                      .tabelaFreteRotaVig.tabelaFreteRota
                                      .regiaoOrigem.cd
                                  }}
                                  -
                                  {{
                                    item.docCargaDoc.cargaDoc
                                      .cargaDocUnidadeCarga[0]
                                      .pedidoUnidadeCarga
                                      .pedidoUnidadeCargaTrecho[0]
                                      .tabelaFreteRotaVig.tabelaFreteRota
                                      .regiaoOrigem.descr
                                  }}</span
                                >
                                <span
                                  v-if="
                                    item.docCargaDoc.cargaDoc
                                      .cargaDocUnidadeCarga[0]
                                      .pedidoUnidadeCarga
                                      .pedidoUnidadeCargaTrecho[0]
                                      .tabelaFreteRotaVig.tabelaFreteRota
                                      .regiaoOrigem == null
                                  "
                                >
                                  Não constado</span
                                >
                              </b-col>
                              <b-col md="3">
                                <label>Região de Destino: </label>
                                <span
                                  v-if="
                                    item.docCargaDoc.cargaDoc
                                      .cargaDocUnidadeCarga[0]
                                      .pedidoUnidadeCarga
                                      .pedidoUnidadeCargaTrecho[0]
                                      .tabelaFreteRotaVig.tabelaFreteRota
                                      .regiaoDestino != null
                                  "
                                >
                                  {{
                                    item.docCargaDoc.cargaDoc
                                      .cargaDocUnidadeCarga[0]
                                      .pedidoUnidadeCarga
                                      .pedidoUnidadeCargaTrecho[0]
                                      .tabelaFreteRotaVig.tabelaFreteRota
                                      .regiaoDestino.cd
                                  }}
                                  -
                                  {{
                                    item.docCargaDoc.cargaDoc
                                      .cargaDocUnidadeCarga[0]
                                      .pedidoUnidadeCarga
                                      .pedidoUnidadeCargaTrecho[0]
                                      .tabelaFreteRotaVig.tabelaFreteRota
                                      .regiaoDestino.descr
                                  }}
                                </span>
                                <span
                                  v-if="
                                    item.docCargaDoc.cargaDoc
                                      .cargaDocUnidadeCarga[0]
                                      .pedidoUnidadeCarga
                                      .pedidoUnidadeCargaTrecho[0]
                                      .tabelaFreteRotaVig.tabelaFreteRota
                                      .regiaoDestino == null
                                  "
                                >
                                  Não constado</span
                                >
                              </b-col>
                            </b-row>
                            <b-row class="p-a-0">
                              <b-col>
                                <label><strong>Tabela de frete:</strong></label>
                                <span>
                                  {{
                                    item.docCargaDoc.cargaDoc
                                      .cargaDocUnidadeCarga[0]
                                      .pedidoUnidadeCarga
                                      .pedidoUnidadeCargaTrecho[0]
                                      .tabelaFreteRotaVig.tabelaFreteRota
                                      .tabelaFrete.cd
                                  }}
                                  -
                                  {{
                                    item.docCargaDoc.cargaDoc
                                      .cargaDocUnidadeCarga[0]
                                      .pedidoUnidadeCarga
                                      .pedidoUnidadeCargaTrecho[0]
                                      .tabelaFreteRotaVig.tabelaFreteRota
                                      .tabelaFrete.descr
                                  }}
                                </span>
                              </b-col>
                              <b-col>
                                <label><strong>Data Aprovação</strong></label>
                                <span>
                                  {{
                                    formatDate(
                                      item.docCargaDoc.cargaDoc
                                        .cargaDocUnidadeCarga[0]
                                        .pedidoUnidadeCarga
                                        .pedidoUnidadeCargaTrecho[0]
                                        .tabelaFreteRotaVig.dtAprovacao
                                    )
                                  }}
                                </span>
                              </b-col>
                              <b-col>
                                <label><strong>Tipo de Calculo</strong></label>
                                <span>
                                  {{
                                    item.docCargaDoc.cargaDoc
                                      .cargaDocUnidadeCarga[0]
                                      .pedidoUnidadeCarga
                                      .pedidoUnidadeCargaTrecho[0]
                                      .tabelaFreteRotaVig.tabelaFreteRota
                                      .tabelaFrete.tpCalculo
                                  }}
                                </span>
                              </b-col>
                              <b-col>
                                <label><strong>Valor faixa</strong></label>
                                <span
                                  v-if="item.docCargaDoc.doc.tpDoc.valor == 1"
                                >
                                  {{ formatNumber(item.vlrFaixa) }}
                                </span>
                              </b-col>
                              <b-col>
                                <label><strong>Range faixa</strong></label>
                                <span
                                  v-if="item.docCargaDoc.doc.tpDoc.valor == 1"
                                >
                                  {{ formatNumber(item.vlrFaixaIni) }} -
                                  {{ formatNumber(item.vlrFaixaFim) }}
                                </span>
                              </b-col>
                              <b-col>
                                <label><strong>Vigência</strong></label>
                                <span>
                                  {{
                                    formatDate(
                                      item.docCargaDoc.cargaDoc
                                        .cargaDocUnidadeCarga[0]
                                        .pedidoUnidadeCarga
                                        .pedidoUnidadeCargaTrecho[0]
                                        .tabelaFreteRotaVig.dtVigenciaIni
                                    )
                                  }}
                                  até
                                  {{
                                    formatDate(
                                      item.docCargaDoc.cargaDoc
                                        .cargaDocUnidadeCarga[0]
                                        .pedidoUnidadeCarga
                                        .pedidoUnidadeCargaTrecho[0]
                                        .tabelaFreteRotaVig.dtVigenciaFim
                                    )
                                  }}
                                </span>
                              </b-col>
                            </b-row>
                          </b-tab>

                          <!-- <b-tab title="Meio de transporte">
                            &lt;!&ndash; <div v-for="frota in this.dados.tipo_frota">
                        <b-row class="p-a-0" id="row" style="margin-top: 10px;">
                            <b-col md="2">
                                <label>Tipo de carroceria:  </label>
                                <span> {{frota.tp_carroceria}}</span>
                            </b-col>
                            <b-col md="2">
                                <label>Tipo rodado: </label>
                                <span> {{frota.tp_rodado}}</span>
                            </b-col>
                        </b-row>
                    </div> &ndash;&gt;
                          </b-tab> -->
                        </b-tabs>
                      </div>
                      <!--.tab-pane-->
                    </div>
                  </section>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <!--.tab-pane-->
        <div
          role="tabpanel"
          class="tab-pane fade"
          v-bind:id="'t3' + rowData.docfisId + ''"
        >
          <table class="table" id="mais">
            <thead>
              <tr>
                <th style="width: 5%">N° MDFE</th>
                <th style="width: 10%">Dt Emissão</th>
                <th style="width: 5%">N° Romaneio</th>
                <th style="width: 10%">Dt Emissão</th>
                <th style="width: 5%">Peso(kg)</th>
                <th style="width: 20%">Chave</th>
                <th style="width: 5%">Qtd.NF</th>
                <th style="width: 5%">Qtd.CTE</th>
                <th style="width: 10%">Usuário Emissor</th>
                <th style="width: 10%">Usuário Evento</th>
                <th style="width: 5%">Data Evento</th>
                <th style="width: 5%">Status</th>
                <th style="width: 5%">Ações</th>
              </tr>
            </thead>
            <tbody v-for="item in rowData.cargaDocReentrega">
              <tr
                class="bg-gray-light"
                style="display: table-row"
                v-if="item.carga != null && item.carga.tpCarga == 2 && item.carga.status.valor == 3"
              >
                <td>
                  <span v-if="showMdfe(item)">
                    {{ item.docCargaDoc.doc.manifestoDoc.manifesto.numFiscal }}
                  </span>
                </td>
                <td>
                  <span v-if="showMdfe(item)">
                    {{ formatDate(item.docCargaDoc.doc.manifestoDoc.manifesto.dtEmi) }}
                  </span>
                </td>
                <td>
                  <span v-if="item.carga.tpOperacaoPrincipal == 3">
                    {{ item.carga.numCarga }}
                  </span>
                </td>
                <td>
                  <span v-if="item.carga.tpOperacaoPrincipal == 3">
                    {{ formatDate(item.carga.dtExpedicao) }}
                  </span>
                </td>
                <td>
                  <span>
                    {{ formatNumber(rowData.pesoBrutoTotal) }}
                  </span>
                </td>
                <td>
                  <span v-if="showMdfe(item)">
                    {{ item.docCargaDoc.doc.manifestoDoc.manifesto.chaveMdfe }}
                  </span>
                </td>
                <td>
                  <span>
                    {{ rowData.qtdTotalNf }}
                  </span>
                </td>
                <td>
                  <span>
                    {{ rowData.qtdTotalCte }}
                  </span>
                </td>
                <td>
                  <span
                    v-if="
                      showMdfe(item) &&
                      item.docCargaDoc.doc.manifestoDoc.manifesto.usuarioInc.pessoa != null
                    "
                  >
                    {{
                      setNomeSobrenome(
                        item.docCargaDoc.doc.manifestoDoc.manifesto.usuarioInc.pessoa.pessoaFisica.nome
                      )
                    }}
                  </span>
                </td>
                <td>
                  <span
                    v-if="
                      showMdfe(item) &&
                      item.docCargaDoc.doc.manifestoDoc.manifesto.manifestoEvento.length > 0 &&
                      item.docCargaDoc.doc.manifestoDoc.manifesto.manifestoEvento[0].usuarioInc
                        .pessoa != null
                    "
                  >
                    {{
                      setNomeSobrenome(
                        item.docCargaDoc.doc.manifestoDoc.manifesto.manifestoEvento[0].usuarioInc
                          .pessoa.pessoaFisica.nome
                      )
                    }}
                  </span>
                </td>
                <td>
                  <span
                    v-if="
                      showMdfe(item) &&
                      item.docCargaDoc.doc.manifestoDoc.manifesto.manifestoEvento.length > 0
                    "
                  >
                    {{
                      formatDate(
                        item.docCargaDoc.doc.manifestoDoc.manifesto.manifestoEvento[0].sefazDtHrEvento
                      )
                    }}
                  </span>
                </td>
                <td>
                  <span
                    class="badge badge-danger"
                    v-if="
                      showMdfe(item) &&
                      item.docCargaDoc.doc.manifestoDoc.manifesto.status.valor == 14
                    "
                    >{{ item.docCargaDoc.doc.manifestoDoc.manifesto.status.descr }}</span
                  >
                  <span
                    class="badge badge-info"
                    v-if="
                      showMdfe(item) &&
                      item.docCargaDoc.doc.manifestoDoc.manifesto.status.valor == 21
                    "
                    >{{ item.docCargaDoc.doc.manifestoDoc.manifesto.status.descr }}</span
                  >
                  <span
                    class="badge badge-warning"
                    v-if="
                      showMdfe(item) &&
                      item.docCargaDoc.doc.manifestoDoc.manifesto.status.valor == 34
                    "
                    >{{ item.docCargaDoc.doc.manifestoDoc.manifesto.status.descr }}</span
                  >
                  <span
                    class="badge badge-warning"
                    v-if="
                      showMdfe(item) &&
                      item.docCargaDoc.doc.manifestoDoc.manifesto.status.valor == 31
                    "
                    >{{ item.docCargaDoc.doc.manifestoDoc.manifesto.status.descr }}</span
                  >
                  <span
                    class="badge badge-danger"
                    v-if="
                      showMdfe(item) &&
                      item.docCargaDoc.doc.manifestoDoc.manifesto.status.valor == 9
                    "
                    >{{ item.docCargaDoc.doc.manifestoDoc.manifesto.status.descr }}</span
                  >
                  <span
                    class="badge badge-danger"
                    v-if="
                      showMdfe(item) &&
                      item.docCargaDoc.doc.manifestoDoc.manifesto.status.valor == 8
                    "
                    >{{ item.docCargaDoc.doc.manifestoDoc.manifesto.status.descr }}</span
                  >
                  <span
                    class="badge badge-danger"
                    v-if="
                      showMdfe(item) &&
                      item.docCargaDoc.doc.manifestoDoc.manifesto.status.valor == 7
                    "
                    >{{ item.docCargaDoc.doc.manifestoDoc.manifesto.status.descr }}</span
                  >
                  <span
                    class="badge badge-warning"
                    v-if="
                      showMdfe(item) &&
                      item.docCargaDoc.doc.manifestoDoc.manifesto.status.valor == 22
                    "
                    >{{ item.docCargaDoc.doc.manifestoDoc.manifesto.status.descr }}</span
                  >
                  <span
                    class="badge badge-warning"
                    v-if="
                      showMdfe(item) &&
                      item.docCargaDoc.doc.manifestoDoc.manifesto.status.valor == 12
                    "
                    >{{ item.docCargaDoc.doc.manifestoDoc.manifesto.status.descr }}</span
                  >
                  <span
                    class="badge badge-success"
                    v-if="
                      showMdfe(item) &&
                      item.docCargaDoc.doc.manifestoDoc.manifesto.status.valor == 6
                    "
                    >{{ item.docCargaDoc.doc.manifestoDoc.manifesto.status.descr }}</span
                  >
                  <span
                    class="badge badge-info"
                    v-if="
                      showMdfe(item) &&
                      item.docCargaDoc.doc.manifestoDoc.manifesto.status.valor == 3
                    "
                    >{{ item.docCargaDoc.doc.manifestoDoc.manifesto.status.descr }}</span
                  >
                  <span
                    class="badge badge-info"
                    v-if="
                      showMdfe(item) &&
                      item.docCargaDoc.doc.manifestoDoc.manifesto.status.valor == 32
                    "
                    >{{ item.docCargaDoc.doc.manifestoDoc.manifesto.status.descr }}</span
                  >
                  <span
                    class="badge badge-info"
                    v-if="
                      showMdfe(item) &&
                      item.docCargaDoc.doc.manifestoDoc.manifesto.status.valor == 2
                    "
                    >{{ item.docCargaDoc.doc.manifestoDoc.manifesto.status.descr }}</span
                  >
                  <span
                    class="badge badge-warning"
                    v-if="
                      showMdfe(item) &&
                      item.docCargaDoc.doc.manifestoDoc.manifesto.status.valor == 1
                    "
                    >{{ item.docCargaDoc.doc.manifestoDoc.manifesto.status.descr }}</span
                  >
                  <span
                    class="badge badge-warning"
                    v-if="
                      showMdfe(item) &&
                      item.docCargaDoc.doc.manifestoDoc.manifesto.status.valor == 4
                    "
                    >{{ item.docCargaDoc.doc.manifestoDoc.manifesto.status.descr }}</span
                  >
                  <span
                    class="badge badge-warning"
                    v-if="
                      showMdfe(item) &&
                      item.docCargaDoc.doc.manifestoDoc.manifesto.status.valor == 5
                    "
                    >{{ item.docCargaDoc.doc.manifestoDoc.manifesto.status.descr }}</span
                  >
                  <span
                    class="badge badge-warning"
                    v-if="
                      showMdfe(item) &&
                      item.docCargaDoc.doc.manifestoDoc.manifesto.status.valor == 11
                    "
                    >{{ item.docCargaDoc.doc.manifestoDoc.manifesto.status.descr }}</span
                  >
                </td>
                <td>
                  <a
                    v-if="showMdfe(item)"
                    @click="onExportCsv(item.docCargaDoc.doc.manifestoDoc.manifesto.manifestoId)"
                    v-b-tooltip
                    title="Exportar chaves em .csv"
                    ><i class="fa fa-file-code-o"></i
                  ></a>
                  <a
                    v-if="item.carga.tpOperacaoPrincipal == 3"
                    @click="onPrintRomaneio(item.carga.cargaId)"
                    v-b-tooltip
                    title="Imprimir romaneio"
                    ><i class="fa fa-file-code-o"></i
                  ></a>
                  <span
                    v-if="
                      showMdfe(item) &&
                      (item.docCargaDoc.doc.manifestoDoc.manifesto.status.valor == 6 ||
                        item.docCargaDoc.doc.manifestoDoc.manifesto.status.valor == 11 ||
                        item.docCargaDoc.doc.manifestoDoc.manifesto.status.valor == 21)
                    "
                    ><a
                      @click="onImprimirMdfe(item.docCargaDoc.doc.manifestoDoc.manifesto.manifestoId)"
                      v-b-tooltip
                      title="Imprimir MDFE"
                      ><i class="fa fa-print"></i></a
                  ></span>
                  <span
                    v-if="
                      showMdfe(item) &&
                      item.docCargaDoc.doc.manifestoDoc.manifesto.manifestoXml.length > 0
                    "
                    ><a
                      @click="
                        onDownloadXmlMdfe(item.docCargaDoc.doc.manifestoDoc.manifesto.manifestoId)
                      "
                      v-b-tooltip
                      title="Download Xml"
                      ><i class="fa fa-download"></i></a
                  ></span>
                  <div v-if="rowData.cargaDoc.docCargaDoc && rowData.cargaDoc.docCargaDoc.doc.tpDoc.valor == 2">
                    <span v-if="getPermission('cte.imprimir')">
                      <span>
                        <a
                          @click="
                            onDownloadXml(
                              null,
                              rowData.cargaDoc.docCargaDoc.doc.docRps.docrpsId
                            )
                          "
                          v-if="
                            rowData.cargaDoc.docCargaDoc.doc.docRps.docRpsXml
                              .length > 0
                          "
                          v-b-tooltip
                          title="Download XML"
                          ><i class="fa fa-code"></i
                        ></a>
                      </span>
                    </span>
                  </div>
                  <a
                    @click="onExportNotfis(rowData.docfisId)"
                    v-b-tooltip
                    title="Exportar Notfis"
                    ><i class="ft-download"></i
                  ></a>
                  <span v-if="rowData.cargaDoc.docCargaDoc">
                    <span>
                      <a
                        @click="
                          onImprimirRps(
                            rowData.cargaDoc.docCargaDoc.doc.docId,
                            rowData.cargaDoc.docCargaDoc.doc.tpDoc.valor
                          )
                        "
                        v-if="rowData.cargaDoc.docCargaDoc.doc.docRps != null"
                        v-b-tooltip
                        title="Imprimir RPS"
                        ><i class="fa fa-download"></i
                      ></a>
                    </span>
                  </span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <!--.tab-pane-->
        <div
          role="tabpanel"
          class="tab-pane fade"
          v-if="rowData.cargaBipDocMany.length > 0"
          v-bind:id="'t4' + rowData.docfisId + ''"
        >
          <table class="table" id="mais">
            <thead>
              <tr>
                <th style="width: 5%">N° Fiscal</th>
                <th style="width: 5%">Carga</th>
                <th style="width: 10%">Valor NF</th>
                <th style="width: 5%">Peso NF</th>
                <th style="width: 5%">Qtde.</th>
                <th style="width: 15%">CNPJ Emi.</th>
                <th style="width: 25%">Razão Social Emi.</th>
                <th style="width: 15%">Redespacho</th>
                <th style="width: 15%">Usuário Liberação Especial</th>
                <th style="width: 15%">Dt. Liberação Especial</th>
                <th style="width: 5%">Status</th>
                <th style="width: 5%">Ações</th>
              </tr>
            </thead>
            <tbody v-for="item in rowData.cargaBipDocMany">
              <tr :class="onRowClass(item)" style="display: table-row">
                <td>{{ rowData.numFiscal }}</td>
                <td>{{ item.cargaId }}</td>
                <td>R$ {{ formatNumber(rowData.vlrTotalNfs) }}</td>
                <td>{{ formatNumber(rowData.pesoBrutoTotalNf) }}</td>
                <td>
                  {{ rowData.qtdNotasBipadasMontagem }}/{{
                    rowData.qtdTotalBipVolumes
                  }}
                </td>
                <td>
                  {{ ajustaMascara(rowData.docFiscalPartesEnv.emiCnpj) }}
                </td>
                <td>{{ rowData.docFiscalPartesEnv.emiNome }}</td>
                <td>{{ rowData.docFiscalPartesEnv.redNome }}</td>
                <td>
                  <span
                    v-if="
                      rowData.cargaDoc.carga.usuarioLiberacaoMontagem != null
                    "
                  >
                    {{ rowData.cargaDoc.carga.usuarioLiberacaoMontagem.email }}
                  </span>
                </td>
                <td>
                  <span
                    v-if="rowData.cargaDoc.carga.dtLiberacaoMontagem != null"
                  >
                    {{
                      formatDateSeconds(
                        rowData.cargaDoc.carga.dtLiberacaoMontagem
                      )
                    }}
                  </span>
                </td>
                <td>
                  <span
                    class="badge badge-success"
                    v-if="
                      rowData.cargaDoc.carga.status.valor == 3 ||
                      rowData.cargaDoc.carga.status.valor == 6
                    "
                    >{{ rowData.cargaDoc.carga.status.descr }}</span
                  >
                  <span
                    class="badge badge-warning"
                    v-if="rowData.cargaDoc.carga.status.valor == 1"
                    >{{ rowData.cargaDoc.carga.status.descr }}</span
                  >
                </td>
                <td>
                  <a
                    @click="onDetail(item.carbipdocId)"
                    v-b-tooltip
                    title="Ver Detalhes"
                    ><i class="fa fa-plus"></i
                  ></a>
                </td>
              </tr>
              <tr v-if="isVisibleDetail(item.carbipdocId)">
                <td colspan="12">
                  <section class="tabs-section">
                    <ul
                      class="nav nav-tabs nav-topline nav-justified"
                      role="tablist"
                    >
                      <li class="nav-item">
                        <a class="nav-link active" role="tab" data-toggle="tab">
                          <span class="nav-link-in"> Volumes </span>
                        </a>
                      </li>
                    </ul>
                    <div class="tab-content">
                      <div
                        role="tabpanel"
                        class="tab-pane fade in active show pt-1 border-color-detalhes-grey"
                        v-bind:id="'tbmc4' + item.carbipdocId + ''"
                      >
                        <table
                          :class="['vuetable table table-striped tbl-typical']"
                        >
                          <thead>
                            <tr>
                              <th style="width: 10%">N° Volume</th>
                              <th style="width: 35%">Status do Volume</th>
                              <th style="width: 35%">Usuario Bip</th>
                              <th style="width: 35%">Data Bip</th>
                            </tr>
                          </thead>
                          <tbody v-for="(item2, i) in item.cargaBipDocVolume">
                            <tr
                              class="bg-gray-light"
                              style="display: table-row"
                            >
                              <td>
                                {{ item2.numVolume }}
                              </td>
                              <td>
                                <span
                                  class="badge badge-success"
                                  v-if="item2.statusMontagem.valor == 1"
                                  >{{ item2.statusMontagem.descr }}</span
                                >
                                <span
                                  class="badge badge-danger"
                                  v-if="item2.statusMontagem.valor == 2"
                                  >{{ item2.statusMontagem.descr }}</span
                                >
                                <span
                                  class="badge badge-warning"
                                  v-if="item2.statusMontagem.valor == 3"
                                  >{{ item2.statusMontagem.descr }} - Via
                                  seleção / Inserido via chave de CTe</span
                                >
                              </td>
                              <td>
                                <span v-if="item2.usuarioBipMontagem != null">{{
                                  item2.usuarioBipMontagem.pessoa.pessoaFisica
                                    .nome
                                }}</span>
                                <span v-if="item2.statusMontagem.valor == 3">{{
                                  item2.usuarioInc.pessoa.pessoaFisica.nome
                                }}</span>
                              </td>
                              <td>
                                <span v-if="item2.usuarioBipMontagem != null">{{
                                  formatDateSeconds(item2.dtBipMontagem)
                                }}</span>
                                <span v-if="item2.statusMontagem.valor == 3">{{
                                  formatDateSeconds(item2.dtInc)
                                }}</span>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </section>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <!--.tab-pane-->
        <div
          role="tabpanel"
          class="tab-pane fade"
          v-if="rowData.cargaBipDocMany.length > 0"
          v-bind:id="'t5' + rowData.docfisId + ''"
        >
          <table class="table" id="mais">
            <thead>
              <tr>
                <th style="width: 5%">N° Fiscal</th>
                <th style="width: 5%">Carga</th>
                <th style="width: 10%">Valor NF</th>
                <th style="width: 5%">Peso</th>
                <th style="width: 5%">Qtde.</th>
                <th style="width: 15%">CNPJ Emi.</th>
                <th style="width: 25%">Razão Social Emi.</th>
                <th style="width: 15%">Redespacho</th>
                <th style="width: 15%">Exige conferência ?</th>
                <th style="width: 15%">Usuário Liberação Especial</th>
                <th style="width: 15%">Dt. Liberação Especial</th>
                <th style="width: 5%">Status</th>
                <th style="width: 5%">Ações</th>
              </tr>
            </thead>
            <tbody v-for="item in rowData.cargaBipDocMany">
              <tr :class="onRowClass(item)" style="display: table-row">
                <td>{{ rowData.numFiscal }}</td>
                <td>{{ item.cargaId }}</td>
                <td>R$ {{ formatNumber(rowData.vlrTotalNfs) }}</td>
                <td>{{ formatNumber(rowData.pesoBrutoTotal) }}</td>
                <td>
                  {{ rowData.qtdNotasBipadasExpedicao }}/{{
                    rowData.qtdTotalBipVolumes
                  }}
                </td>
                <td>
                  {{ ajustaMascara(rowData.docFiscalPartesEnv.emiCnpj) }}
                </td>
                <td>{{ rowData.docFiscalPartesEnv.emiNome }}</td>
                <td>{{ rowData.docFiscalPartesEnv.redNome }}</td>
                <td>
                  <span
                    class="badge badge-danger"
                    v-if="rowData.exigeConferenciaExp.valor == 2"
                    >{{ rowData.exigeConferenciaExp.descr }}</span
                  >
                  <span
                    class="badge badge-success"
                    v-if="rowData.exigeConferenciaExp.valor == 1"
                    >{{ rowData.exigeConferenciaExp.descr }}</span
                  >
                </td>
                <td>
                  <span
                    v-if="
                      rowData.cargaDoc.carga.usuarioLiberacaoExpedicao != null
                    "
                  >
                    {{ rowData.cargaDoc.carga.usuarioLiberacaoExpedicao.email }}
                  </span>
                </td>
                <td>
                  <span
                    v-if="rowData.cargaDoc.carga.dtLiberacaoExpedicao != null"
                  >
                    {{
                      formatDateSeconds(
                        rowData.cargaDoc.carga.dtLiberacaoExpedicao
                      )
                    }}
                  </span>
                </td>
                <td>
                  <span
                    class="badge badge-success"
                    v-if="
                      rowData.cargaDoc.carga.status.valor == 3 ||
                      rowData.cargaDoc.carga.status.valor == 6
                    "
                    >{{ rowData.cargaDoc.carga.status.descr }}</span
                  >
                  <span
                    class="badge badge-warning"
                    v-if="rowData.cargaDoc.carga.status.valor == 1"
                    >{{ rowData.cargaDoc.carga.status.descr }}</span
                  >
                </td>
                <td>
                  <a
                    @click="onDetail(item.carbipdocId)"
                    v-b-tooltip
                    title="Ver Detalhes"
                    ><i class="fa fa-plus"></i
                  ></a>
                </td>
              </tr>

              <tr v-if="isVisibleDetail(item.carbipdocId)">
                <td colspan="12">
                  <section class="tabs-section">
                    <ul
                      class="nav nav-tabs nav-topline nav-justified"
                      role="tablist"
                    >
                      <li class="nav-item">
                        <a class="nav-link active" role="tab" data-toggle="tab">
                          <span class="nav-link-in"> Volumes </span>
                        </a>
                      </li>
                    </ul>
                    <div class="tab-content">
                      <div
                        role="tabpanel"
                        class="tab-pane fade in active show pt-1 border-color-detalhes-grey"
                        v-bind:id="'tbe4' + item.carbipdocId + ''"
                      >
                        <table
                          :class="['vuetable table table-striped tbl-typical']"
                        >
                          <thead>
                            <tr>
                              <th style="width: 10%">N° Volume</th>
                              <th style="width: 35%">Status do Volume</th>
                              <th style="width: 35%">Usuario Bip</th>
                              <th style="width: 35%">Data Bip</th>
                            </tr>
                          </thead>
                          <tbody v-for="(item2, i) in item.cargaBipDocVolume">
                            <tr
                              class="bg-gray-light"
                              style="display: table-row"
                            >
                              <td>
                                {{ item2.numVolume }}
                              </td>
                              <td>
                                <span
                                  class="badge badge-success"
                                  v-if="item2.statusExpedicao.valor == 1"
                                  >{{ item2.statusExpedicao.descr }}</span
                                >
                                <span
                                  class="badge badge-danger"
                                  v-if="item2.statusExpedicao.valor == 2"
                                  >{{ item2.statusExpedicao.descr }}</span
                                >
                                <span
                                  class="badge badge-warning"
                                  v-if="item2.statusExpedicao.valor == 3"
                                  >{{ item2.statusExpedicao.descr }}</span
                                >
                              </td>
                              <td>
                                <span
                                  v-if="item2.usuarioBipExpedicao != null"
                                  >{{
                                    item2.usuarioBipExpedicao.pessoa
                                      .pessoaFisica.nome
                                  }}</span
                                >
                              </td>
                              <td>
                                {{ formatDateSeconds(item2.dtBipExpedicao) }}
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </section>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <!--.tab-pane-->
        <div
          role="tabpanel"
          class="tab-pane fade"
          v-bind:id="'t6' + rowData.docfisId + ''"
          v-if="rowData.docTranspDocfis != null"
        >
          <table class="table" id="mais">
            <thead>
              <tr>
                <th style="width: 5%">Tipo Doc.</th>
                <th style="width: 10%">N° Doc</th>
                <th style="width: 5%">Série</th>
                <th style="width: 10%">Dt. Lançamento</th>
                <th style="width: 10%">Vlr. Doc</th>
                <th style="width: 10%">Dt. Emissão</th>
                <th style="width: 10%">Dt. Vencimento</th>
                <th style="width: 10%">Status ERP</th>
                <th style="width: 10%">Status</th>
                <th style="width: 10%">Ações</th>
              </tr>
            </thead>
            <tbody
              v-for="(item, i) in rowData.docTranspDocfis.docTransp
                .preFaturaDespesaDoc"
            >
              <tr
                class="bg-gray-light"
                style="display: table-row"
                v-if="item.preFaturaDespesaDoc != null"
              >
                <td>
                  <span class="badge badge-success"
                    >Pré Fatura - {{ item.preFaturaDespesa.tpPreFatura }}</span
                  >
                </td>
                <td>
                  <span v-if="item.preFaturaDespesa != null">
                    {{ item.preFaturaDespesa.numFiscal }}
                  </span>
                </td>
                <td>
                  <span v-if="item.preFaturaDespesa != null">
                    {{ item.preFaturaDespesa.serie }}
                  </span>
                </td>
                <td>
                  <span v-if="item.preFaturaDespesa != null">
                    {{ formatDate(item.preFaturaDespesa.dtInc) }}
                  </span>
                </td>
                <td>
                  <span v-if="rowData.docTranspDocfis != null">
                    {{ formatNumber(item.preFaturaDespesa.vlrPreFatura) }}
                  </span>
                </td>

                <td>
                  <span v-if="item.preFaturaDespesa != null">
                    {{ formatDate(item.preFaturaDespesa.dtEmi) }}
                  </span>
                </td>
                <td>
                  <span v-if="item.preFaturaDespesa != null">
                    {{ formatDate(item.preFaturaDespesa.dtVencto) }}
                  </span>
                </td>
                <td></td>
                <td>
                  <span
                    class="badge badge-secondary"
                    v-if="item.preFaturaDespesa.status.valor == 1"
                    >{{ item.preFaturaDespesa.status.descr }}
                  </span>
                  <span
                    class="badge badge-success"
                    v-if="item.preFaturaDespesa.status.valor == 2"
                    >{{ item.preFaturaDespesa.status.descr }}
                  </span>
                  <span
                    class="badge badge-warning"
                    v-if="item.preFaturaDespesa.status.valor == 3"
                    >{{ item.preFaturaDespesa.status.descr }}
                  </span>
                  <span
                    class="badge badge-danger"
                    v-if="item.preFaturaDespesa.status.valor == 4"
                    >{{ item.preFaturaDespesa.status.descr }}
                  </span>
                  <span
                    class="badge badge-info"
                    v-if="item.preFaturaDespesa.status.valor == 5"
                    >{{ item.preFaturaDespesa.status.descr }}
                  </span>
                </td>
                <td>
                  <a
                    @click="onDetail(item.prefatdesdocId)"
                    v-b-tooltip
                    title="Ver Detalhes"
                    ><i class="fa fa-plus"></i
                  ></a>
                </td>
              </tr>

              <tr v-if="isVisibleDetail(item.prefatdesdocId)">
                <td colspan="12">
                  <section class="tabs-section">
                    <div class="tab-content">
                      <div
                        role="tabpanel"
                        class="tab-pane fade in active show pt-1 border-color-detalhes-grey"
                        v-bind:id="'tr5' + item.prefatdesdocId + ''"
                      >
                        <table
                          :class="['vuetable table table-striped tbl-typical']"
                        >
                          <thead>
                            <tr>
                              <th style="width: 10%">Dt. e Horario</th>
                              <th style="width: 10%">Usuario Inc.</th>
                              <th style="width: 10%">Qtd.Nf</th>
                              <th style="width: 10%">Qtd.CTE</th>
                              <th style="width: 10%">Dt. Conferência</th>
                              <th style="width: 10%">Usuario Conferência</th>
                              <th style="width: 10%">Dt. Reprova</th>
                              <th style="width: 10%">Usuario Reprovação</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr
                              class="bg-gray-light"
                              style="display: table-row"
                            >
                              <td>
                                <span>
                                  {{ formatDate(item.preFaturaDespesa.dtInc) }}
                                </span>
                              </td>
                              <td>
                                <span>
                                  {{ item.preFaturaDespesa.usuarioInc.email }}
                                </span>
                              </td>
                              <td>
                                {{
                                  rowData.docTranspDocfis.docTransp
                                    .preFaturaDespesaDoc.length
                                }}
                              </td>
                              <td>
                                {{
                                  rowData.docTranspDocfis.docTransp
                                    .qtdeTotalCtes
                                }}
                              </td>
                              <td>
                                <span>
                                  {{
                                    formatDate(
                                      item.preFaturaDespesa.dtLiberacao
                                    )
                                  }}
                                </span>
                              </td>
                              <td>
                                <span
                                  v-if="
                                    item.preFaturaDespesa.usuarioLiberacao !=
                                    null
                                  "
                                >
                                  {{
                                    item.preFaturaDespesa.usuarioLiberacao.email
                                  }}
                                </span>
                              </td>
                              <td>
                                <span>
                                  {{
                                    formatDate(
                                      item.preFaturaDespesa.dtCancelamento
                                    )
                                  }}
                                </span>
                              </td>
                              <td>
                                <span
                                  v-if="
                                    item.preFaturaDespesa.usuarioCancelamento !=
                                    null
                                  "
                                >
                                  {{
                                    item.preFaturaDespesa.usuarioCancelamento
                                      .email
                                  }}
                                </span>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </section>
                </td>
              </tr>
            </tbody>

            <!--FATURA DESPESA-->

            <tbody
              v-for="(item, i) in rowData.docTranspDocfis.docTransp
                .faturaDespesaDoc"
            >
              <tr
                class="bg-gray-light"
                style="display: table-row"
                v-if="item.faturaDespesa != null"
              >
                <td>
                  <span class="badge badge-info"
                    >Fatura - {{ item.faturaDespesa.tpFatura }}</span
                  >
                </td>
                <td>
                  <span v-if="item.faturaDespesa != null">
                    {{ item.faturaDespesa.numFiscal }}
                  </span>
                </td>
                <td>
                  <span v-if="item.faturaDespesa != null">
                    {{ item.faturaDespesa.serie }}
                  </span>
                </td>
                <td>
                  <span v-if="item.faturaDespesa != null">
                    {{ formatDate(item.faturaDespesa.dtInc) }}
                  </span>
                </td>
                <td>
                  <span v-if="rowData.docTranspDocfis != null">
                    {{ formatNumber(item.faturaDespesa.vlrFatura) }}
                  </span>
                </td>

                <td>
                  <span v-if="item.faturaDespesa != null">
                    {{ formatDate(item.faturaDespesa.dtEmi) }}
                  </span>
                </td>
                <td>
                  <span v-if="item.faturaDespesa != null">
                    {{ formatDate(item.faturaDespesa.dtVencto) }}
                  </span>
                </td>
                <td>
                  <span
                    class="badge badge-success"
                    v-if="item.faturaDespesa.statusEnvioIntegracao.valor == 1"
                    >{{ item.faturaDespesa.statusEnvioIntegracao.descr }}
                  </span>
                  <span
                    class="badge badge-warning"
                    v-if="item.faturaDespesa.statusEnvioIntegracao.valor == 2"
                    >{{ item.faturaDespesa.statusEnvioIntegracao.descr }}
                  </span>
                  <span
                    class="badge badge-danger"
                    v-if="item.faturaDespesa.statusEnvioIntegracao.valor == 3"
                    >{{ item.faturaDespesa.statusEnvioIntegracao.descr }}
                  </span>
                </td>
                <td>
                  <span
                    class="badge badge-secondary"
                    v-if="item.faturaDespesa.status.valor == 1"
                    >{{ item.faturaDespesa.status.descr }}
                  </span>
                  <span
                    class="badge badge-success"
                    v-if="item.faturaDespesa.status.valor == 2"
                    >{{ item.faturaDespesa.status.descr }}
                  </span>
                  <span
                    class="badge badge-warning"
                    v-if="item.faturaDespesa.status.valor == 3"
                    >{{ item.faturaDespesa.status.descr }}
                  </span>
                  <span
                    class="badge badge-danger"
                    v-if="item.faturaDespesa.status.valor == 4"
                    >{{ item.faturaDespesa.status.descr }}
                  </span>
                  <span
                    class="badge badge-info"
                    v-if="item.faturaDespesa.status.valor == 5"
                    >{{ item.faturaDespesa.status.descr }}
                  </span>
                </td>
                <td>
                  <a
                    @click="onDetail(item.fatdesdocId)"
                    v-b-tooltip
                    title="Ver Detalhes"
                    ><i class="fa fa-plus"></i
                  ></a>
                </td>
              </tr>

              <tr v-if="isVisibleDetail(item.fatdesdocId)">
                <td colspan="12">
                  <section class="tabs-section">
                    <div class="tab-content">
                      <div
                        role="tabpanel"
                        class="tab-pane fade in active show pt-1 border-color-detalhes-grey"
                        v-bind:id="'tr5' + item.fatdesdocId + ''"
                      >
                        <table
                          :class="['vuetable table table-striped tbl-typical']"
                        >
                          <thead>
                            <tr>
                              <th style="width: 10%">Dt. e Horario</th>
                              <th style="width: 10%">Usuario Inc.</th>
                              <th style="width: 10%">Qtd.Nf</th>
                              <th style="width: 10%">Qtd.CTE</th>
                              <th style="width: 10%">Dt. Conferência</th>
                              <th style="width: 10%">Usuario Conferência</th>
                              <th style="width: 10%">Dt. Reprova</th>
                              <th style="width: 10%">Usuario Reprovação</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr
                              class="bg-gray-light"
                              style="display: table-row"
                            >
                              <td>
                                <span>
                                  {{ formatDate(item.faturaDespesa.dtInc) }}
                                </span>
                              </td>
                              <td>
                                <span>
                                  {{ item.faturaDespesa.usuarioInc.email }}
                                </span>
                              </td>
                              <td>
                                {{
                                  rowData.docTranspDocfis.docTransp
                                    .faturaDespesaDoc.length
                                }}
                              </td>
                              <td>
                                {{
                                  rowData.docTranspDocfis.docTransp
                                    .qtdeTotalCtes
                                }}
                              </td>
                              <td>
                                <span>
                                  {{
                                    formatDate(item.faturaDespesa.dtLiberacao)
                                  }}
                                </span>
                              </td>
                              <td>
                                <span
                                  v-if="
                                    item.faturaDespesa.usuarioLiberacao != null
                                  "
                                >
                                  {{
                                    item.faturaDespesa.usuarioLiberacao.email
                                  }}
                                </span>
                              </td>
                              <td>
                                <span>
                                  {{
                                    formatDate(
                                      item.faturaDespesa.dtCancelamento
                                    )
                                  }}
                                </span>
                              </td>
                              <td>
                                <span
                                  v-if="
                                    item.faturaDespesa.usuarioCancelamento !=
                                    null
                                  "
                                >
                                  {{
                                    item.faturaDespesa.usuarioCancelamento.email
                                  }}
                                </span>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </section>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <!--.tab-pane-->
        <div
          role="tabpanel"
          class="tab-pane fade"
          v-if="
            rowData.cargaDoc != null &&
            rowData.cargaDoc.pedidoUnidadeCargaTrechoDoc[0] != null &&
            rowData.cargaDoc.pedidoUnidadeCargaTrechoDoc[0]
              .pedidoUnidadeCargaTrecho.pedidoUnidadeCargaTrechoAudit != null &&
            rowData.cargaDoc.pedidoUnidadeCargaTrechoDoc[0]
              .pedidoUnidadeCargaTrecho.pedidoUnidadeCargaTrechoAudit
              .auditoriaFrete.docTransp != null
          "
          v-bind:id="'t7' + rowData.docfisId + ''"
        >
          <table class="table" id="mais">
            <thead>
              <tr>
                <th style="width: 5%">Tipo Doc.</th>
                <th style="width: 5%">N° Cte/Rps</th>
                <th style="width: 5%">Serie</th>
                <th style="width: 20%">Chave</th>
                <th style="width: 5%">Qtde. NF</th>
                <th style="width: 5%">Qtde. CTe</th>
                <th style="width: 10%">Data Emissão</th>
                <th style="width: 5%">Vlr.Doc</th>
                <th style="width: 15%">Nome Emitente</th>
                <th style="width: 10%">CNPJ/CPF Emitente</th>
                <th style="width: 5%">Vlr.Calculo</th>
                <th style="width: 5%">Status</th>
                <th style="width: 5%">Ações</th>
              </tr>
            </thead>
            <tbody v-for="item in rowData.cargaDoc.pedidoUnidadeCargaTrechoDoc">
              <tr
                class="bg-gray-light"
                style="display: table-row"
                v-if="item.pedidoUnidadeCargaTrecho.tpCusto == 2"
              >
                <td>
                  <span
                    v-if="
                      item.pedidoUnidadeCargaTrecho
                        .pedidoUnidadeCargaTrechoAudit != null &&
                      item.pedidoUnidadeCargaTrecho
                        .pedidoUnidadeCargaTrechoAudit.auditoriaFrete
                        .docTransp != null
                    "
                  >
                    {{
                      item.pedidoUnidadeCargaTrecho
                        .pedidoUnidadeCargaTrechoAudit.auditoriaFrete.docTransp
                        .livTpDoc.descr
                    }}
                  </span>
                </td>
                <td>
                  <span
                    v-if="
                      item.pedidoUnidadeCargaTrecho
                        .pedidoUnidadeCargaTrechoAudit != null &&
                      item.pedidoUnidadeCargaTrecho
                        .pedidoUnidadeCargaTrechoAudit.auditoriaFrete
                        .docTransp != null
                    "
                  >
                    {{
                      item.pedidoUnidadeCargaTrecho
                        .pedidoUnidadeCargaTrechoAudit.auditoriaFrete.docTransp
                        .numDoc
                    }}
                  </span>
                </td>
                <td>
                  <span
                    v-if="
                      item.pedidoUnidadeCargaTrecho
                        .pedidoUnidadeCargaTrechoAudit != null &&
                      item.pedidoUnidadeCargaTrecho
                        .pedidoUnidadeCargaTrechoAudit.auditoriaFrete
                        .docTransp != null
                    "
                  >
                    {{
                      item.pedidoUnidadeCargaTrecho
                        .pedidoUnidadeCargaTrechoAudit.auditoriaFrete.docTransp
                        .serie
                    }}
                  </span>
                </td>
                <td>
                  <span
                    v-if="
                      item.pedidoUnidadeCargaTrecho
                        .pedidoUnidadeCargaTrechoAudit != null &&
                      item.pedidoUnidadeCargaTrecho
                        .pedidoUnidadeCargaTrechoAudit.auditoriaFrete
                        .docTransp != null
                    "
                  >
                    {{
                      item.pedidoUnidadeCargaTrecho
                        .pedidoUnidadeCargaTrechoAudit.auditoriaFrete.docTransp
                        .chave
                    }}
                  </span>
                </td>
                <td>
                  <span
                    v-if="
                      item.pedidoUnidadeCargaTrecho
                        .pedidoUnidadeCargaTrechoAudit != null &&
                      item.pedidoUnidadeCargaTrecho
                        .pedidoUnidadeCargaTrechoAudit.auditoriaFrete
                        .docTransp != null
                    "
                  >
                    {{
                      item.pedidoUnidadeCargaTrecho
                        .pedidoUnidadeCargaTrechoAudit.auditoriaFrete.docTransp
                        .totalNfs
                    }}
                  </span>
                </td>
                <td>
                  <span
                    v-if="
                      item.pedidoUnidadeCargaTrecho
                        .pedidoUnidadeCargaTrechoAudit != null &&
                      item.pedidoUnidadeCargaTrecho
                        .pedidoUnidadeCargaTrechoAudit.auditoriaFrete
                        .docTransp != null
                    "
                  >
                    {{
                      item.pedidoUnidadeCargaTrecho
                        .pedidoUnidadeCargaTrechoAudit.auditoriaFrete.docTransp
                        .auditoriaFrete.pedidoUnidadeCargaTrechoAudit.length
                    }}
                  </span>
                </td>
                <td>
                  <span
                    v-if="
                      item.pedidoUnidadeCargaTrecho
                        .pedidoUnidadeCargaTrechoAudit != null &&
                      item.pedidoUnidadeCargaTrecho
                        .pedidoUnidadeCargaTrechoAudit.auditoriaFrete
                        .docTransp != null
                    "
                  >
                    {{
                      formatDate(
                        item.pedidoUnidadeCargaTrecho
                          .pedidoUnidadeCargaTrechoAudit.auditoriaFrete
                          .docTransp.dtEmissao
                      )
                    }}
                  </span>
                </td>
                <td>
                  <span
                    v-if="
                      item.pedidoUnidadeCargaTrecho
                        .pedidoUnidadeCargaTrechoAudit != null &&
                      item.pedidoUnidadeCargaTrecho
                        .pedidoUnidadeCargaTrechoAudit.auditoriaFrete
                        .docTransp != null
                    "
                  >
                    {{
                      formatNumber(
                        item.pedidoUnidadeCargaTrecho
                          .pedidoUnidadeCargaTrechoAudit.auditoriaFrete
                          .docTransp.docTranspVlrPrestacao.vlrReceber
                      )
                    }}
                  </span>
                </td>
                <td>
                  <span
                    v-if="
                      item.pedidoUnidadeCargaTrecho
                        .pedidoUnidadeCargaTrechoAudit != null &&
                      item.pedidoUnidadeCargaTrecho
                        .pedidoUnidadeCargaTrechoAudit.auditoriaFrete
                        .docTransp != null
                    "
                  >
                    {{
                      item.pedidoUnidadeCargaTrecho
                        .pedidoUnidadeCargaTrechoAudit.auditoriaFrete.docTransp
                        .docTranspPartesEnv.emiNome
                    }}
                  </span>
                </td>
                <td>
                  <span
                    v-if="
                      item.pedidoUnidadeCargaTrecho
                        .pedidoUnidadeCargaTrechoAudit != null &&
                      item.pedidoUnidadeCargaTrecho
                        .pedidoUnidadeCargaTrechoAudit.auditoriaFrete
                        .docTransp != null
                    "
                  >
                    {{
                      ajustaMascara(
                        item.pedidoUnidadeCargaTrecho
                          .pedidoUnidadeCargaTrechoAudit.auditoriaFrete
                          .docTransp.docTranspPartesEnv.emiCnpj
                      )
                    }}
                  </span>
                </td>
                <td>
                  <span
                    v-if="
                      item.pedidoUnidadeCargaTrecho
                        .pedidoUnidadeCargaTrechoAudit != null &&
                      item.pedidoUnidadeCargaTrecho
                        .pedidoUnidadeCargaTrechoAudit.auditoriaFrete
                        .docTransp != null
                    "
                  >
                    {{
                      formatNumber(
                        item.pedidoUnidadeCargaTrecho
                          .pedidoUnidadeCargaTrechoAudit.auditoriaFrete
                          .docTransp.vlrCalculo
                      )
                    }}
                  </span>
                </td>
                <td>
                  <span
                    class="badge badge-warning"
                    v-if="
                      item.pedidoUnidadeCargaTrecho
                        .pedidoUnidadeCargaTrechoAudit.auditoriaFrete.status
                        .valor == 1
                    "
                    >{{
                      item.pedidoUnidadeCargaTrecho
                        .pedidoUnidadeCargaTrechoAudit.auditoriaFrete.status
                        .descr
                    }}
                  </span>
                  <span
                    class="badge badge-info"
                    v-if="
                      item.pedidoUnidadeCargaTrecho
                        .pedidoUnidadeCargaTrechoAudit.auditoriaFrete.status
                        .valor == 2
                    "
                    >{{
                      item.pedidoUnidadeCargaTrecho
                        .pedidoUnidadeCargaTrechoAudit.auditoriaFrete.status
                        .descr
                    }}
                  </span>
                  <span
                    class="badge badge-warning"
                    v-if="
                      item.pedidoUnidadeCargaTrecho
                        .pedidoUnidadeCargaTrechoAudit.auditoriaFrete.status
                        .valor == 3
                    "
                    >{{
                      item.pedidoUnidadeCargaTrecho
                        .pedidoUnidadeCargaTrechoAudit.auditoriaFrete.status
                        .descr
                    }}
                  </span>
                  <span
                    class="badge badge-danger"
                    v-if="
                      item.pedidoUnidadeCargaTrecho
                        .pedidoUnidadeCargaTrechoAudit.auditoriaFrete.status
                        .valor == 4
                    "
                    >{{
                      item.pedidoUnidadeCargaTrecho
                        .pedidoUnidadeCargaTrechoAudit.auditoriaFrete.status
                        .descr
                    }}
                  </span>
                </td>
                <td>
                  <a
                    @click="onDetail(rowData.docfisId)"
                    v-b-tooltip
                    v-if="
                      item.pedidoUnidadeCargaTrecho
                        .pedidoUnidadeCargaTrechoAudit != null &&
                      item.pedidoUnidadeCargaTrecho
                        .pedidoUnidadeCargaTrechoAudit.auditoriaFrete
                        .docTransp != null
                    "
                    title="Ver Detalhes"
                    ><i class="fa fa-plus"></i
                  ></a>
                </td>
              </tr>

              <tr
                v-if="
                  isVisibleDetail(rowData.docfisId) &&
                  item.pedidoUnidadeCargaTrecho.tpCusto == 2
                "
              >
                <td colspan="12">
                  <section class="tabs-section">
                    <div class="tab-content">
                      <div
                        role="tabpanel"
                        class="tab-pane fade in active show pt-1 border-color-detalhes-grey"
                        v-bind:id="'tr5' + rowData.docfisId + ''"
                      >
                        <table
                          :class="['vuetable table table-striped tbl-typical']"
                        >
                          <thead>
                            <tr>
                              <th style="width: 10%">Usuario Inc.</th>
                              <th style="width: 10%">Dt. e Horario</th>
                              <th style="width: 10%">Usuario Assoc.</th>
                              <th style="width: 10%">Data Assoc.</th>
                              <th style="width: 10%">Dt. Conferência</th>
                              <th style="width: 10%">Usuario Conferência</th>
                              <th style="width: 10%">Dt. Aprovação</th>
                              <th style="width: 10%">Usuario Aprovação</th>
                              <th style="width: 10%">Dt. Reprova</th>
                              <th style="width: 10%">Usuario Reprovação</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr
                              class="bg-gray-light"
                              style="display: table-row"
                            >
                              <td>
                                <span
                                  v-if="
                                    item.pedidoUnidadeCargaTrecho
                                      .pedidoUnidadeCargaTrechoAudit != null &&
                                    item.pedidoUnidadeCargaTrecho
                                      .pedidoUnidadeCargaTrechoAudit
                                      .auditoriaFrete.docTransp != null
                                  "
                                >
                                  {{
                                    item.pedidoUnidadeCargaTrecho
                                      .pedidoUnidadeCargaTrechoAudit
                                      .auditoriaFrete.usuarioInc.email
                                  }}
                                </span>
                              </td>
                              <td>
                                <span
                                  v-if="
                                    item.pedidoUnidadeCargaTrecho
                                      .pedidoUnidadeCargaTrechoAudit != null &&
                                    item.pedidoUnidadeCargaTrecho
                                      .pedidoUnidadeCargaTrechoAudit
                                      .auditoriaFrete.docTransp != null
                                  "
                                >
                                  {{
                                    formatDate(
                                      item.pedidoUnidadeCargaTrecho
                                        .pedidoUnidadeCargaTrechoAudit
                                        .auditoriaFrete.dtInc
                                    )
                                  }}
                                </span>
                              </td>
                              <td>
                                <span
                                  v-if="
                                    item.pedidoUnidadeCargaTrecho
                                      .pedidoUnidadeCargaTrechoAudit != null
                                  "
                                >
                                  {{
                                    item.pedidoUnidadeCargaTrecho
                                      .pedidoUnidadeCargaTrechoAudit.usuarioInc
                                      .email
                                  }}
                                </span>
                              </td>
                              <td>
                                <span
                                  v-if="
                                    item.pedidoUnidadeCargaTrecho
                                      .pedidoUnidadeCargaTrechoAudit != null &&
                                    item.pedidoUnidadeCargaTrecho
                                      .pedidoUnidadeCargaTrechoAudit
                                      .auditoriaFrete.docTransp != null
                                  "
                                >
                                  {{
                                    formatDate(
                                      item.pedidoUnidadeCargaTrecho
                                        .pedidoUnidadeCargaTrechoAudit.dtInc
                                    )
                                  }}
                                </span>
                              </td>
                              <td>
                                <span
                                  v-if="
                                    item.pedidoUnidadeCargaTrecho
                                      .pedidoUnidadeCargaTrechoAudit != null &&
                                    item.pedidoUnidadeCargaTrecho
                                      .pedidoUnidadeCargaTrechoAudit
                                      .auditoriaFrete.docTransp != null
                                  "
                                >
                                  {{
                                    formatDate(
                                      item.pedidoUnidadeCargaTrecho
                                        .pedidoUnidadeCargaTrechoAudit
                                        .auditoriaFrete.dtConferencia
                                    )
                                  }}
                                </span>
                              </td>
                              <td>
                                <span
                                  v-if="
                                    item.pedidoUnidadeCargaTrecho
                                      .pedidoUnidadeCargaTrechoAudit != null &&
                                    item.pedidoUnidadeCargaTrecho
                                      .pedidoUnidadeCargaTrechoAudit
                                      .auditoriaFrete.docTransp != null &&
                                    item.pedidoUnidadeCargaTrecho
                                      .pedidoUnidadeCargaTrechoAudit
                                      .auditoriaFrete.usuarioConferencia != null
                                  "
                                >
                                  {{
                                    item.pedidoUnidadeCargaTrecho
                                      .pedidoUnidadeCargaTrechoAudit
                                      .auditoriaFrete.usuarioConferencia.email
                                  }}
                                </span>
                              </td>
                              <td>
                                <span
                                  v-if="
                                    item.pedidoUnidadeCargaTrecho
                                      .pedidoUnidadeCargaTrechoAudit != null &&
                                    item.pedidoUnidadeCargaTrecho
                                      .pedidoUnidadeCargaTrechoAudit
                                      .auditoriaFrete.docTransp != null
                                  "
                                >
                                  {{
                                    formatDate(
                                      item.pedidoUnidadeCargaTrecho
                                        .pedidoUnidadeCargaTrechoAudit
                                        .auditoriaFrete.dtAprovacao
                                    )
                                  }}
                                </span>
                              </td>
                              <td>
                                <span
                                  v-if="
                                    item.pedidoUnidadeCargaTrecho
                                      .pedidoUnidadeCargaTrechoAudit != null &&
                                    item.pedidoUnidadeCargaTrecho
                                      .pedidoUnidadeCargaTrechoAudit
                                      .auditoriaFrete.docTransp != null &&
                                    item.pedidoUnidadeCargaTrecho
                                      .pedidoUnidadeCargaTrechoAudit
                                      .auditoriaFrete.usuarioAprovacao != null
                                  "
                                >
                                  {{
                                    item.pedidoUnidadeCargaTrecho
                                      .pedidoUnidadeCargaTrechoAudit
                                      .auditoriaFrete.usuarioAprovacao.email
                                  }}
                                </span>
                              </td>
                              <td>
                                <span
                                  v-if="
                                    item.pedidoUnidadeCargaTrecho
                                      .pedidoUnidadeCargaTrechoAudit != null &&
                                    item.pedidoUnidadeCargaTrecho
                                      .pedidoUnidadeCargaTrechoAudit
                                      .auditoriaFrete.docTransp != null
                                  "
                                >
                                  {{
                                    formatDate(
                                      item.pedidoUnidadeCargaTrecho
                                        .pedidoUnidadeCargaTrechoAudit
                                        .auditoriaFrete.dtReprovado
                                    )
                                  }}
                                </span>
                              </td>
                              <td>
                                <span
                                  v-if="
                                    item.pedidoUnidadeCargaTrecho
                                      .pedidoUnidadeCargaTrechoAudit != null &&
                                    item.pedidoUnidadeCargaTrecho
                                      .pedidoUnidadeCargaTrechoAudit
                                      .auditoriaFrete.docTransp != null &&
                                    item.pedidoUnidadeCargaTrecho
                                      .pedidoUnidadeCargaTrechoAudit
                                      .auditoriaFrete.usuarioReprovacao != null
                                  "
                                >
                                  {{
                                    item.pedidoUnidadeCargaTrecho
                                      .pedidoUnidadeCargaTrechoAudit
                                      .auditoriaFrete.usuarioReprovacao.email
                                  }}
                                </span>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </section>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <!--.tab-pane-->
      </div>
      <!--.tab-content-->
    </div>
  </div>
</template>

  <script>
import moment from "moment";
import accounting from "accounting";

import { formatCNPJFromParts } from "../utils";
import OcorrenciaIntegracaoErro from "../components/OcorrenciaIntegracaoErro";
import {
  COPIA_FALHA_MENSAGEM,
  COPIA_FALHA_TITULO,
  COPIA_SUCESSO_MENSAGEM,
  COPIA_SUCESSO_TITULO,
} from "../constants/ocorrenciaIntegracaoCopy";
import {
  resolverEstadoIntegracao,
  textoParaChamado,
} from "../utils/ocorrenciaIntegracaoEstado";

export default {
  components: {
    OcorrenciaIntegracaoErro,
  },
  data() {
    return {
      helpForm: new Form({
        recordCollection: [],
        status: "",
        carocorren_id: "",
        lay_id: "",
        carga_id: "",
        manifesto_id: "",
        docs: [],
      }),
      /**
       * Instância PRÓPRIA do reenvio de ocorrência (TMS-8396).
       *
       * Existe por causa do OVERRIDE-FORM-ONFAIL abaixo: `onFail` é
       * sobrescrito na INSTÂNCIA, não no método, então usar o `helpForm`
       * compartilhado faria os outros 7 consumidores desta view (`onExportCsv`,
       * `onImprimirMdfe`, `onDownloadXmlMdfe`, `onExportNotfis`, `onReenvioErp`,
       * `onPrintRomaneio` e a ENTREGA de `this.helpForm` a
       * `$refs.vinculardocumentounidadeform`, que faz o próprio `patch` com ela)
       * passarem a exibir toast em `type == 3` — comportamento que nenhum deles
       * teve, e no caso da entrega o vazamento cruzaria a fronteira de
       * componente.
       *
       * Só `carocorren_id` porque é o único campo que
       * `InclusaoOcorrenciaController@reenvio` lê; `Form.data()` envia
       * exatamente `originalData`, então o payload fica menor e não há campo
       * herdado de outra ação atravessando a requisição.
       */
      reenvioOcorrenciaForm: new Form({
        carocorren_id: "",
      }),
      cnpj_formatado: "",
      visibleDetailRows: [],
      formimprimir: new Form({
        doc_id: "",
        doc_id_pdf: [],
        doccte_id: "",
        docrps_id: "",
        tpDoc: "",
        tp_doc: "",
        tp_print: "",
      }),
    };
  },
  props: {
    rowData: {
      type: Object,
      required: true,
    },
    rowIndex: {
      type: Number,
    },
  },
  created() {
    // OVERRIDE-FORM-ONFAIL (TMS-7218)
    // `Form.submit` rejeita apenas o `errors` do envelope quando `type == 3`
    // (Form.js), e o 422 do reenvio traz `errors` vazio: a `message` morreria
    // antes de chegar ao operador. `onFail` e o ponto de extensao da classe
    // Form e recebe o envelope completo, entao e por ele que a mensagem sai.
    //
    // Acoplamento com a TMS-6598: se o conserto do `Form.js` passar a
    // notificar o usuario centralmente, esta view exibira a mensagem do 422
    // duas vezes e nao ha teste no repo que pegue. Ao mexer em `Form.onFail`,
    // grepe por OVERRIDE-FORM-ONFAIL antes.
    //
    // O alvo e `reenvioOcorrenciaForm`, NUNCA o `helpForm`: a sobrescrita e na
    // INSTANCIA, entao no `helpForm` ela vazaria para os outros 7 consumidores
    // da view, que passariam a exibir toast em `type == 3` (TMS-8396 FE-04).
    const reenvioForm = this.reenvioOcorrenciaForm;
    const onFailOriginal = reenvioForm.onFail.bind(reenvioForm);

    reenvioForm.onFail = (envelope) => {
      onFailOriginal(envelope);
      this.notificaRetorno(envelope);
    };
  },
  methods: {
        onFormataCnpj(cnpj_base, cnpj_filial, cnpj_digito) {
      return formatCNPJFromParts(cnpj_base, cnpj_filial, cnpj_digito);
    },
    DateFormat: function (date) {
      if (date != null) {
        return moment(date, "YYYY-MM-DD").format("DD/MM/YYYY");
      }
      return "";
    },
    formatDate(value, fmt = "D/MM/YYYY HH:mm") {
      return value == null ? "" : moment(value, "YYYY-MM-DD HH:mm").format(fmt);
    },
    formatDateSeconds(value, fmt = "D/MM/YYYY HH:mm:ss") {
      return value == null
        ? ""
        : moment(value, "YYYY-MM-DD HH:mm:ss").format(fmt);
    },
    onActivateDesactivate(action, data, tipo) {
      // Tipo = true = Checkbox
      this.helpForm.status = action;
      if (tipo) {
        this.helpForm.recordCollection = [];
        this.helpForm.recordCollection.push(data.unidoc_id);
      } else {
        this.helpForm.recordCollection = [];
        this.$refs.vuetable.selectedTo.forEach((obj) => {
          this.helpForm.recordCollection.push(obj);
        });
      }
      this.$refs.vinculardocumentounidadeform.onActivateDesactivate(
        this.helpForm
      );
    },
    getPermission(checkPermission) {
      return this.getPermissionFw(checkPermission);
    },
    /* ---------------------------------------------------------------- */
    /* TMS-8396 — estados de erro de integração da ocorrência (ADR-0002) */
    /* ---------------------------------------------------------------- */
    /**
     * Delegador de uma linha. A lógica dos cinco estados vive no helper, nunca
     * na view (ADR-0002 D1) — aqui só se pergunta se a linha tem diagnóstico.
     */
    estadoIntegracao(item) {
      return resolverEstadoIntegracao(item);
    },
    /**
     * Responde UMA pergunta só: o operador pode VER o botão de reenvio?
     *
     * Isto é controle de INTERFACE (`getPermissionFw`). A pergunta seguinte — o
     * botão deve estar ATIVO? — não é respondida aqui: ela é de
     * `isReenvioBloqueado(item)`, dentro de `OcorrenciaIntegracaoErro`, que
     * mantém a ação visível porém inerte e com o tooltip que explica o porquê.
     *
     * NÃO REINTRODUZIR `item.reenvioPermitido !== false` nesta expressão
     * (TMS-8396 FE-04). Somando as duas perguntas num único booleano, a prop
     * `podeReenviar` chegava `false` e o componente REMOVIA a ação inteira no
     * filtro de visibilidade, antes de calcular `habilitada`:
     *   - E2 perdia a ação secundária "Reenviar agora" desabilitada, que o
     *     contrato de decisões do usuário exige;
     *   - E1 com `reenvioPermitido = false` não renderizava ação alguma.
     * Em ambos, quem não pode reenviar deixava de ler o motivo — exatamente o
     * silêncio de tela que esta entrega existe para eliminar.
     *
     * A autoridade sobre o reenvio continua sendo o 422 do endpoint; a guarda
     * do componente é `=== false`, nunca `!item.reenvioPermitido`, para que a
     * chave ausente (o payload anterior ao deploy) não desabilite o botão.
     *
     * A permissão `inclusaoocorrencia.reenvio` é reusada de propósito: é o
     * mesmo endpoint e o mesmo 422. Criar `posicaonotafiscal.reenvio` exigiria
     * cadastro no backend e esta frente é frontend puro — checar contra uma
     * permissão que ninguém possui esconderia o botão de todo mundo.
     *
     * A saída antecipada evita consultar permissão nas linhas sem diagnóstico,
     * que são a maioria da grade; o componente já não renderiza nada nelas.
     */
    podeReenviarOcorrencia(item) {
      if (this.estadoIntegracao(item) === null) {
        return false;
      }

      return this.getPermissionFw("inclusaoocorrencia.reenvio");
    },
    notificaRetorno(envelope) {
      if (!envelope || !envelope.message) {
        return;
      }

      // Whitelist em vez de `this.$snotify[tp_message]`: o valor vem do
      // backend e indexar o objeto direto aceitaria herdados de
      // `Object.prototype` (`tp_message: "toString"` passaria no teste).
      const TIPOS_VALIDOS = ["success", "info", "warning", "error"];
      const tipo =
        TIPOS_VALIDOS.indexOf(envelope.tp_message) !== -1
          ? envelope.tp_message
          : "warning";

      this.$snotify[tipo](envelope.message, envelope.title || "");
    },
    onReenvioOcorrencia(carocorrenId) {
      // Instância própria, e não o `helpForm`: ver OVERRIDE-FORM-ONFAIL no
      // `created()` e o JSDoc de `reenvioOcorrenciaForm` no `data()`.
      this.reenvioOcorrenciaForm.carocorren_id = carocorrenId;
      this.reenvioOcorrenciaForm
        .patch("/api/inclusaoocorrencia/reenvio")
        .then((response) => {
          // `refresh = false`: o recarregamento da grid e feito pelo evento
          // abaixo, e nao pela varredura de `$parent` do ReturnApi.
          new ReturnApi(response, this, true, false, false);
          // A ref `vuetable` vive no componente pai; este detail row e
          // renderizado pelo Vuetable via `<component :is>`, sem listener,
          // entao `$emit` nao chega ao pai. O barramento `vue-events` e o
          // mecanismo ja usado no repo para recarregar a grid.
          this.$events.fire("posicaonotafiscal-reload");
        })
        .catch((errors) => {
          // Quando `type == 3` o Form rejeita a string vazia do campo `errors`
          // e a mensagem ja foi exibida por `notificaRetorno`. Chamar o
          // ReturnApi com um valor primitivo lancaria TypeError.
          if (!errors || typeof errors !== "object") {
            return;
          }

          new ReturnApi(errors, this, true, false, false, false);

          // DESVIO DELIBERADO do molde de `InclusaoOcorrenciaDetalhes.vue:505`
          // (TMS-8396): o acumulo em `this.errors_array` NAO e replicado aqui.
          // Esta view nao declara `errors_array` no `data()` e nao tem onde
          // renderiza-lo — copiar o trecho criaria atribuicao nao reativa e
          // silenciosamente inutil, que e a armadilha documentada no proprio
          // comentario da referencia. Os seis usos pre-existentes de
          // `errors_array` neste arquivo sao exatamente esse defeito; nao se
          // acrescenta um setimo.
        });
    },
    /**
     * "Abrir chamado com estes dados" não abre chamado: não existe integração
     * com o Service Desk neste repositório (ADR-0002 D5). A ação copia o bloco
     * já preenchido com carga, nota, ocorrência e motivo, e instrui a colagem.
     *
     * Técnica portada do precedente da squad em `Expedicao.vue` (TMS-7247) —
     * copiada, nunca importada, porque aquele arquivo não está em `production`.
     */
    onCopiarDadosChamado(item) {
      const texto = textoParaChamado(item);

      if (!texto) {
        return;
      }

      const confirmar = () => {
        this.$snotify.success(COPIA_SUCESSO_MENSAGEM, COPIA_SUCESSO_TITULO);
      };
      const falhar = () => {
        this.$snotify.error(COPIA_FALHA_MENSAGEM, COPIA_FALHA_TITULO);
      };

      if (
        navigator.clipboard &&
        typeof navigator.clipboard.writeText === "function"
      ) {
        navigator.clipboard
          .writeText(texto)
          .then(confirmar)
          .catch(() => {
            if (this.copiaTextoViaTextarea(texto)) {
              confirmar();
            } else {
              falhar();
            }
          });
        return;
      }

      if (this.copiaTextoViaTextarea(texto)) {
        confirmar();
      } else {
        falhar();
      }
    },
    copiaTextoViaTextarea(texto) {
      try {
        const area = document.createElement("textarea");
        area.value = texto;
        area.setAttribute("readonly", "");
        area.style.position = "fixed";
        area.style.top = "-1000px";
        area.style.left = "-1000px";
        area.style.opacity = "0";
        document.body.appendChild(area);
        area.select();
        area.setSelectionRange(0, texto.length);
        const copiou = document.execCommand("copy");
        document.body.removeChild(area);
        return copiou;
      } catch (erro) {
        return false;
      }
    },
    ajustaMascara(data) {
      if (data != null) {
        if (data.length == 11) {
          //cpf
          return data.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, "$1.$2.$3-$4");
        }
        if (data.length == 14) {
          //cnpj
          return data.replace(
            /([A-Z0-9]{2})([A-Z0-9]{3})([A-Z0-9]{3})([A-Z0-9]{4})([A-Z0-9]{2})/,
            "$1.$2.$3/$4-$5"
          );
        }
      }
    },
    onExportCsv(data) {
      this.helpForm.manifesto_id = data;
      this.loading = true;
      this.isDisabled = true;
      this.helpForm
        .post("/api/exportacaodocfiscal/mdfe/chave")
        .then((response) => {
          new ReturnApi(response, this, true, false, false, false);
        })
        .catch((errors) => {
          new ReturnApi(errors, this, true, null, null, false);
          this.errors_array = "";
          this.errors_array = [];
          for (var property in errors) {
            if (errors.hasOwnProperty(property)) {
              if (typeof errors[property] === "object") {
                errors[property].forEach((obj) => {
                  this.errors_array.push({
                    erro: obj,
                  });
                });
              }
            }
          }
        });
    },
    onImprimirMdfe(data) {
      this.helpForm.manifesto_id = [data];
      this.helpForm
        .post("/api/mdfe/imprimir")
        .then((response) => {
          new ReturnApi(response, this, true, false, false);
        })
        .catch((errors) => {
          new ReturnApi(errors, this);
        });
    },
    onDownloadXmlMdfe(data) {
      this.loading = true;
      this.isDisabled = true;
      this.helpForm.manifesto_id = data;
      this.helpForm
        .post("/api/mdfe/downloadxml")
        .then((response) => {
          new ReturnApi(response, this, true, null, null, false);
        })
        .catch((errors) => {
          new ReturnApi(errors, this, true, null, null, false);
          this.errors_array = "";
          this.errors_array = [];
          for (var property in errors) {
            if (errors.hasOwnProperty(property)) {
              if (typeof errors[property] === "object") {
                errors[property].forEach((obj) => {
                  this.errors_array.push({
                    erro: obj,
                  });
                });
              }
            }
          }
        });
    },
    onImprimirRps(data, tpDoc) {
      this.loading = true;
      this.isDisabled = true;
      this.formimprimir.doc_id = data;
      this.formimprimir.tpDoc = tpDoc;
      this.formimprimir.tp_doc = tpDoc;
      this.formimprimir
        .post("/api/cte/imprimirps")
        .then((response) => {
          new ReturnApi(response, this, true, null, null, false);
        })
        .catch((errors) => {
          new ReturnApi(errors, this, true, null, null, false);
        });
    },
    onDownloadXml(doccte_id, docrps_id) {
      this.loading = true;
      this.isDisabled = true;
      this.formimprimir.doccte_id = doccte_id;
      this.formimprimir.docrps_id = docrps_id;
      this.formimprimir
        .post("/api/cte/downloadxml")
        .then((response) => {
          new ReturnApi(response, this, true, null, null, false);
        })
        .catch((errors) => {
          new ReturnApi(errors, this, true, null, null, false);
          this.errors_array = "";
          this.errors_array = [];
          for (var property in errors) {
            if (errors.hasOwnProperty(property)) {
              if (typeof errors[property] === "object") {
                errors[property].forEach((obj) => {
                  this.errors_array.push({
                    erro: obj,
                  });
                });
              }
            }
          }
        });
    },
    onExportNotfis(data) {
      this.loading = true;
      this.isDisabled = true;
      this.helpForm.docs.push(data);
      this.helpForm.lay_id = 84;
      this.helpForm
        .post("/api/exportacaodocfiscal/notfis")
        .then((response) => {
          new ReturnApi(response, this);
        })
        .catch((errors) => {
          new ReturnApi(errors, this, true, null, null, false);
          this.errors_array = "";
          this.errors_array = [];
          for (var property in errors) {
            if (errors.hasOwnProperty(property)) {
              if (typeof errors[property] === "object") {
                errors[property].forEach((obj) => {
                  this.errors_array.push({
                    erro: obj,
                  });
                });
              }
            }
          }
        });
    },
    onRowClass(data, index) {
      return data.status.valor == 1 ? "table-warning" : "table-success";
    },
    onImprimirXml(doc_id, tp_print, tpDoc) {
      this.loading = true;
      this.isDisabled = true;
      this.formimprimir.doc_id_pdf = [];
      if (tp_print == 2 || tp_print == 3) {
        this.$refs.vuetable.selectedTo.forEach((obj) => {
          this.formimprimir.doc_id_pdf.push({
            id: obj,
          });
        });
      } else if (tp_print == 1) {
        this.formimprimir.doc_id_pdf.push({
          id: doc_id,
          tpDoc: tpDoc,
        });
      }
      this.formimprimir.tp_print = tp_print;

      this.loading = true;
      this.isDisabled = true;
      this.formimprimir
        .post("/api/cte/imprimircte")
        .then((response) => {
          new ReturnApi(response, this, true, null, null, false);
        })
        .catch((errors) => {
          new ReturnApi(errors, this, true, null, null, false);
        });
    },
    onReenvioErp(id) {
      this.loading = true;
      this.isDisabled = true;
      this.helpForm.carocorren_id = id;
      this.helpForm
        .patch("/api/inclusaoocorrencia/reenvio")
        .then((response) => {
          new ReturnApi(response, this);
          Vue.nextTick(() => this.$refs.vuetable.reload());
        })
        .catch((errors) => {
          new ReturnApi(errors, this, true, null, null, false);
          this.errors_array = "";
          this.errors_array = [];
          for (var property in errors) {
            if (errors.hasOwnProperty(property)) {
              if (typeof errors[property] === "object") {
                errors[property].forEach((obj) => {
                  this.errors_array.push({
                    erro: obj,
                  });
                });
              }
            }
          }
        });
    },
    onPrintRomaneio(carga_id) {
      this.loading = true;
      this.isDisabled = true;
      this.helpForm.carga_id = carga_id;
      this.helpForm
        .post("/api/expedicao/mdferomaneio")
        .then((response) => {
          new ReturnApi(response, this);
          Vue.nextTick(() => this.$refs.vuetable.reload());
        })
        .catch((errors) => {
          new ReturnApi(errors, this, true, null, null, false);
          this.errors_array = "";
          this.errors_array = [];
          for (var property in errors) {
            if (errors.hasOwnProperty(property)) {
              if (typeof errors[property] === "object") {
                errors[property].forEach((obj) => {
                  this.errors_array.push({
                    erro: obj,
                  });
                });
              }
            }
          }
        });
    },
    setNomeSobrenome(data) {
      this.split = data.split(" ");
      return (
        this.split[0] +
        " " +
        (this.split[this.split.length - 1] == this.split[0]
          ? ""
          : this.split[this.split.length - 1])
      );
    },
    formatNumber(value) {
      return accounting.formatNumber(value, 2, ".", ",");
    },
    formatNumberPrecision3(value) {
      return accounting.formatNumber(value, 3);
    },
    onDetail(carocorren_id) {
      this.toggleDetail(carocorren_id);
    },
    isVisibleDetail(rowId) {
      return this.visibleDetailRows.indexOf(rowId) >= 0;
    },
    showDetail(rowId) {
      if (!this.isVisibleDetail(rowId)) {
        this.visibleDetailRows.push(rowId);
      }
    },
    hideDetail(rowId) {
      if (this.isVisibleDetail(rowId)) {
        this.visibleDetailRows.splice(this.visibleDetailRows.indexOf(rowId), 1);
      }
    },
    toggleDetail(rowId) {
      if (this.isVisibleDetail(rowId)) {
        this.hideDetail(rowId);
      } else {
        this.showDetail(rowId);
      }
    },
    goLink(data) {
      window.open(data, "_blank", "noopener");
    },
    showMdfe(item) {
      return item.docCargaDoc != null &&
        item.docCargaDoc.doc != null &&
        item.docCargaDoc.doc.manifestoDoc != null &&
        item.docCargaDoc.doc.manifestoDoc.manifesto != null;
    }
  },
};
</script>